/*
 * jQuery Selectbox plugin 0.2
 *
 * Copyright 2011-2012, Dimitar Ivanov (http://www.bulgaria-web-developers.com/projects/javascript/selectbox/)
 * Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
 *
 * Date: Tue Jul 17 19:58:36 2012 +0300
 */
(function ($, undefined) {
    var PROP_NAME = "selectbox", FALSE = false, TRUE = true;

    function Selectbox() {
        this._state = [];
        this._defaults = {
            classHolder: "sbHolder",
            classHolderDisabled: "sbHolderDisabled",
            classSelector: "sbSelector",
            classOptions: "sbOptions",
            classGroup: "sbGroup",
            classSub: "sbSub",
            classDisabled: "sbDisabled",
            classToggleOpen: "sbToggleOpen",
            classToggle: "sbToggle",
            classFocus: "sbFocus",
            speed: 200,
            effect: "slide",
            onChange: null,
            onOpen: null,
            onClose: null
        }
    }

    $.extend(Selectbox.prototype, {
        _isOpenSelectbox: function (target) {
            if (!target) {
                return FALSE
            }
            var inst = this._getInst(target);
            return inst.isOpen
        }, _isDisabledSelectbox: function (target) {
            if (!target) {
                return FALSE
            }
            var inst = this._getInst(target);
            return inst.isDisabled
        }, _attachSelectbox: function (target, settings) {
            if (this._getInst(target)) {
                return FALSE
            }
            var $target = $(target), self = this, inst = self._newInst($target), sbHolder, sbSelector, sbToggle, sbOptions, s = FALSE, optGroup = $target.find("optgroup"), opts = $target.find("option"), olen = opts.length;
            $target.attr("sb", inst.uid);
            $.extend(inst.settings, self._defaults, settings);
            self._state[inst.uid] = FALSE;
            $target.hide();

            function closeOthers() {
                var key, sel, uid = this.attr("id").split("_")[1];
                for (key in self._state) {
                    if (key !== uid) {
                        if (self._state.hasOwnProperty(key)) {
                            sel = $("select[sb='" + key + "']")[0];
                            if (sel) {
                                self._closeSelectbox(sel)
                            }
                        }
                    }
                }
            }

            sbHolder = $("<div>", {
                id: "sbHolder_" + inst.uid,
                "class": inst.settings.classHolder,
                tabindex: $target.attr("tabindex")
            });
            sbSelector = $("<a>", {
                id: "sbSelector_" + inst.uid,
                href: "#",
                "class": inst.settings.classSelector,
                click: function (e) {
                    e.preventDefault();
                    closeOthers.apply($(this), []);
                    var uid = $(this).attr("id").split("_")[1];
                    if (self._state[uid]) {
                        self._closeSelectbox(target)
                    } else {
                        self._openSelectbox(target)
                    }
                }
            });
            sbToggle = $("<a>", {
                id: "sbToggle_" + inst.uid,
                href: "#",
                "class": inst.settings.classToggle,
                click: function (e) {
                    e.preventDefault();
                    closeOthers.apply($(this), []);
                    var uid = $(this).attr("id").split("_")[1];
                    if (self._state[uid]) {
                        self._closeSelectbox(target)
                    } else {
                        self._openSelectbox(target)
                    }
                }
            });
            sbToggle.appendTo(sbHolder);
            sbOptions = $("<ul>", {
                id: "sbOptions_" + inst.uid,
                "class": inst.settings.classOptions,
                css: {display: "none"}
            });
            $target.children().each(function (i) {
                var that = $(this), li, config = {};
                if (that.is("option")) {
                    getOptions(that)
                } else {
                    if (that.is("optgroup")) {
                        li = $("<li>");
                        $("<span>", {text: that.attr("label")}).addClass(inst.settings.classGroup).appendTo(li);
                        li.appendTo(sbOptions);
                        if (that.is(":disabled")) {
                            config.disabled = true
                        }
                        config.sub = true;
                        getOptions(that.find("option"), config)
                    }
                }
            });

            function getOptions() {
                var sub = arguments[1] && arguments[1].sub ? true : false, disabled = arguments[1] && arguments[1].disabled ? true : false;
                arguments[0].each(function (i) {
                    var that = $(this), li = $("<li>"), child;
                    if (that.is(":selected")) {
                        sbSelector.text(that.text());
                        s = TRUE
                    }
                    if (i === olen - 1) {
                        li.addClass("last")
                    }
                    if (!that.is(":disabled") && !disabled) {
                        child = $("<a>", {
                            href: "#" + that.val(),
                            rel: that.val()
                        }).text(that.text()).bind("click.sb", function (e) {
                            if (e && e.preventDefault) {
                                e.preventDefault()
                            }
                            var t = sbToggle, $this = $(this), uid = t.attr("id").split("_")[1];
                            self._changeSelectbox(target, $this.attr("rel"), $this.text());
                            self._closeSelectbox(target)
                        }).bind("mouseover.sb", function () {
                            var $this = $(this);
                            $this.parent().siblings().find("a").removeClass(inst.settings.classFocus);
                            $this.addClass(inst.settings.classFocus)
                        }).bind("mouseout.sb", function () {
                            $(this).removeClass(inst.settings.classFocus)
                        });
                        if (sub) {
                            child.addClass(inst.settings.classSub)
                        }
                        if (that.is(":selected")) {
                            child.addClass(inst.settings.classFocus)
                        }
                        child.appendTo(li)
                    } else {
                        child = $("<span>", {text: that.text()}).addClass(inst.settings.classDisabled);
                        if (sub) {
                            child.addClass(inst.settings.classSub)
                        }
                        child.appendTo(li)
                    }
                    li.appendTo(sbOptions)
                })
            }

            if (!s) {
                sbSelector.text(opts.first().text())
            }
            $.data(target, PROP_NAME, inst);
            sbHolder.data("uid", inst.uid).bind("keydown.sb", function (e) {
                var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0, $this = $(this), uid = $this.data("uid"), inst = $this.siblings("select[sb='" + uid + "']").data(PROP_NAME), trgt = $this.siblings(["select[sb='", uid, "']"].join("")).get(0),
                    $f = $this.find("ul").find("a." + inst.settings.classFocus);
                switch (key) {
                    case 37:
                    case 38:
                        if ($f.length > 0) {
                            var $next;
                            $("a", $this).removeClass(inst.settings.classFocus);
                            $next = $f.parent().prevAll("li:has(a)").eq(0).find("a");
                            if ($next.length > 0) {
                                $next.addClass(inst.settings.classFocus).focus();
                                $("#sbSelector_" + uid).text($next.text())
                            }
                        }
                        break;
                    case 39:
                    case 40:
                        var $next;
                        $("a", $this).removeClass(inst.settings.classFocus);
                        if ($f.length > 0) {
                            $next = $f.parent().nextAll("li:has(a)").eq(0).find("a")
                        } else {
                            $next = $this.find("ul").find("a").eq(0)
                        }
                        if ($next.length > 0) {
                            $next.addClass(inst.settings.classFocus).focus();
                            $("#sbSelector_" + uid).text($next.text())
                        }
                        break;
                    case 13:
                        if ($f.length > 0) {
                            self._changeSelectbox(trgt, $f.attr("rel"), $f.text())
                        }
                        self._closeSelectbox(trgt);
                        break;
                    case 9:
                        if (trgt) {
                            var inst = self._getInst(trgt);
                            if (inst) {
                                if ($f.length > 0) {
                                    self._changeSelectbox(trgt, $f.attr("rel"), $f.text())
                                }
                                self._closeSelectbox(trgt)
                            }
                        }
                        var i = parseInt($this.attr("tabindex"), 10);
                        if (!e.shiftKey) {
                            i++
                        } else {
                            i--
                        }
                        $("*[tabindex='" + i + "']").focus();
                        break;
                    case 27:
                        self._closeSelectbox(trgt);
                        break
                }
                e.stopPropagation();
                return false
            }).delegate("a", "mouseover", function (e) {
                $(this).addClass(inst.settings.classFocus)
            }).delegate("a", "mouseout", function (e) {
                $(this).removeClass(inst.settings.classFocus)
            });
            sbSelector.appendTo(sbHolder);
            sbOptions.appendTo(sbHolder);
            sbHolder.insertAfter($target);
            $("html").on("mousedown", function (e) {
                e.stopPropagation();
                $("select").selectbox("close")
            });
            $([".", inst.settings.classHolder, ", .", inst.settings.classSelector].join("")).mousedown(function (e) {
                e.stopPropagation()
            })
        }, _detachSelectbox: function (target) {
            var inst = this._getInst(target);
            if (!inst) {
                return FALSE
            }
            $("#sbHolder_" + inst.uid).remove();
            $.data(target, PROP_NAME, null);
            $(target).show()
        }, _changeSelectbox: function (target, value, text) {
            var onChange, inst = this._getInst(target);
            if (inst) {
                onChange = this._get(inst, "onChange");
                $("#sbSelector_" + inst.uid).text(text)
            }
            value = value.replace(/\'/g, "\\'");
            $(target).find("option[value='" + value + "']").attr("selected", TRUE);
            if (inst && onChange) {
                onChange.apply((inst.input ? inst.input[0] : null), [value, inst])
            } else {
                if (inst && inst.input) {
                    inst.input.trigger("change")
                }
            }
        }, _enableSelectbox: function (target) {
            var inst = this._getInst(target);
            if (!inst || !inst.isDisabled) {
                return FALSE
            }
            $("#sbHolder_" + inst.uid).removeClass(inst.settings.classHolderDisabled);
            inst.isDisabled = FALSE;
            $.data(target, PROP_NAME, inst)
        }, _disableSelectbox: function (target) {
            var inst = this._getInst(target);
            if (!inst || inst.isDisabled) {
                return FALSE
            }
            $("#sbHolder_" + inst.uid).addClass(inst.settings.classHolderDisabled);
            inst.isDisabled = TRUE;
            $.data(target, PROP_NAME, inst)
        }, _optionSelectbox: function (target, name, value) {
            var inst = this._getInst(target);
            if (!inst) {
                return FALSE
            }
            inst[name] = value;
            $.data(target, PROP_NAME, inst)
        }, _openSelectbox: function (target) {
            var inst = this._getInst(target);
            if (!inst || inst.isOpen || inst.isDisabled) {
                return
            }
            var el = $("#sbOptions_" + inst.uid), viewportHeight = parseInt($(window).height(), 10), offset = $("#sbHolder_" + inst.uid).offset(), scrollTop = $(window).scrollTop(), height = el.prev().height(), diff = viewportHeight - (offset.top - scrollTop) - height / 2,
                onOpen = this._get(inst, "onOpen");
            el.css({top: height + "px", maxHeight: (diff - height) + "px"});
            inst.settings.effect === "fade" ? el.fadeIn(inst.settings.speed) : el.slideDown(inst.settings.speed);
            $("#sbToggle_" + inst.uid).addClass(inst.settings.classToggleOpen);
            this._state[inst.uid] = TRUE;
            inst.isOpen = TRUE;
            if (onOpen) {
                onOpen.apply((inst.input ? inst.input[0] : null), [inst])
            }
            $.data(target, PROP_NAME, inst)
        }, _closeSelectbox: function (target) {
            var inst = this._getInst(target);
            if (!inst || !inst.isOpen) {
                return
            }
            var onClose = this._get(inst, "onClose");
            inst.settings.effect === "fade" ? $("#sbOptions_" + inst.uid).fadeOut(inst.settings.speed) : $("#sbOptions_" + inst.uid).slideUp(inst.settings.speed);
            $("#sbToggle_" + inst.uid).removeClass(inst.settings.classToggleOpen);
            this._state[inst.uid] = FALSE;
            inst.isOpen = FALSE;
            if (onClose) {
                onClose.apply((inst.input ? inst.input[0] : null), [inst])
            }
            $.data(target, PROP_NAME, inst)
        }, _newInst: function (target) {
            var id = target[0].id.replace(/([^A-Za-z0-9_-])/g, "\\\\$1");
            return {
                id: id,
                input: target,
                uid: Math.floor(Math.random() * 99999999),
                isOpen: FALSE,
                isDisabled: FALSE,
                settings: {}
            }
        }, _getInst: function (target) {
            try {
                return $.data(target, PROP_NAME)
            } catch (err) {
                throw"Missing instance data for this selectbox"
            }
        }, _get: function (inst, name) {
            return inst.settings[name] !== undefined ? inst.settings[name] : this._defaults[name]
        }
    });
    $.fn.selectbox = function (options) {
        var otherArgs = Array.prototype.slice.call(arguments, 1);
        if (typeof options == "string" && options == "isDisabled") {
            return $.selectbox["_" + options + "Selectbox"].apply($.selectbox, [this[0]].concat(otherArgs))
        }
        if (options == "option" && arguments.length == 2 && typeof arguments[1] == "string") {
            return $.selectbox["_" + options + "Selectbox"].apply($.selectbox, [this[0]].concat(otherArgs))
        }
        return this.each(function () {
            typeof options == "string" ? $.selectbox["_" + options + "Selectbox"].apply($.selectbox, [this].concat(otherArgs)) : $.selectbox._attachSelectbox(this, options)
        })
    };
    $.selectbox = new Selectbox();
    $.selectbox.version = "0.2"
})(jQuery);

/*!
 * jQuery Browser Plugin 0.1.0
 * https://github.com/gabceb/jquery-browser-plugin
 *
 * Original jquery-browser code Copyright 2005, 2015 jQuery Foundation, Inc. and other contributors
 * http://jquery.org/license
 *
 * Modifications Copyright 2015 Gabriel Cebrian
 * https://github.com/gabceb
 *
 * Released under the MIT license
 *
 * Date: 23-11-2015
 */
// jQuery is already loaded globally, no need for UMD wrapper
(function (a) {
    "use strict";

    function b(a) {
        void 0 === a && (a = window.navigator.userAgent), a = a.toLowerCase();
        var b = /(edge)\/([\w.]+)/.exec(a) || /(opr)[\/]([\w.]+)/.exec(a) || /(chrome)[ \/]([\w.]+)/.exec(a) || /(iemobile)[\/]([\w.]+)/.exec(a) || /(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(a) || /(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(a) || /(webkit)[ \/]([\w.]+)/.exec(a) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(a) || /(msie) ([\w.]+)/.exec(a) || a.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(a) || a.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(a) || [],
            c = /(ipad)/.exec(a) || /(ipod)/.exec(a) || /(windows phone)/.exec(a) || /(iphone)/.exec(a) || /(kindle)/.exec(a) || /(silk)/.exec(a) || /(android)/.exec(a) || /(win)/.exec(a) || /(mac)/.exec(a) || /(linux)/.exec(a) || /(cros)/.exec(a) || /(playbook)/.exec(a) || /(bb)/.exec(a) || /(blackberry)/.exec(a) || [],
            d = {}, e = {
                browser: b[5] || b[3] || b[1] || "",
                version: b[2] || b[4] || "0",
                versionNumber: b[4] || b[2] || "0",
                platform: c[0] || ""
            };
        if (e.browser && (d[e.browser] = !0, d.version = e.version, d.versionNumber = parseInt(e.versionNumber, 10)), e.platform && (d[e.platform] = !0), (d.android || d.bb || d.blackberry || d.ipad || d.iphone || d.ipod || d.kindle || d.playbook || d.silk || d["windows phone"]) && (d.mobile = !0), (d.cros || d.mac || d.linux || d.win) && (d.desktop = !0), (d.chrome || d.opr || d.safari) && (d.webkit = !0), d.rv || d.iemobile) {
            var f = "msie";
            e.browser = f, d[f] = !0
        }
        if (d.edge) {
            delete d.edge;
            var g = "msedge";
            e.browser = g, d[g] = !0
        }
        if (d.safari && d.blackberry) {
            var h = "blackberry";
            e.browser = h, d[h] = !0
        }
        if (d.safari && d.playbook) {
            var i = "playbook";
            e.browser = i, d[i] = !0
        }
        if (d.bb) {
            var j = "blackberry";
            e.browser = j, d[j] = !0
        }
        if (d.opr) {
            var k = "opera";
            e.browser = k, d[k] = !0
        }
        if (d.safari && d.android) {
            var l = "android";
            e.browser = l, d[l] = !0
        }
        if (d.safari && d.kindle) {
            var m = "kindle";
            e.browser = m, d[m] = !0
        }
        if (d.safari && d.silk) {
            var n = "silk";
            e.browser = n, d[n] = !0
        }
        return d.name = e.browser, d.platform = e.platform, d
    }

    return window.jQBrowser = b(window.navigator.userAgent), window.jQBrowser.uaMatch = b, a && (a.browser = window.jQBrowser), window.jQBrowser
})(window.jQuery);


/* Custom LKW JS*/
var sameHeight = function () {
    var maxHeight = -1;
    $('#home .frontpage-header:not(.frontpage-header-redesign), #home .sidebar').each(function () {
        maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
    });
    $('#home .frontpage-header:not(.frontpage-header-redesign), #home .sidebar').each(function () {
        $(this).height(maxHeight);
    });

    $('#landingpage.auto-h .frontpage-header:not(.frontpage-header-redesign), #landingpage.auto-h .sidebar').each(function () {
        maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
    });
    $('#landingpage.auto-h .frontpage-header:not(.frontpage-header-redesign), #landingpage.auto-h .sidebar').each(function () {
        $(this).height(maxHeight);
    });
};


var newHeight = function () {
    var h1 = $('.ur-choice').height() + 10 * 1;
    var h2 = $('.vehicle-img').height();
    var h3 = $('.details').height();
    var h4 = $('.grey-box').height() + 34 * 1;
    var h5 = $('.basket').height() - 15 * 1;
    var ele = $('.extras .panel-result').height() + 3 * 1;
    var h = h1 * 1 + h2 * 1 + h3 * 1 + h4 * 1 - h5 * 1;
    var height = ele - h;
    //$('.white-box').css('height', height + 'px');
};

var btnControl = function () {
    if ($('.selected-filter .list').children().length > 0) {
        $('.selected-filter').show();
    } else {
        $('.selected-filter').hide();
    }
};

var SaleTabs = function () {
    var w = $('.sales .title').width();
    var i = $('.sales .nav-tabs').children().length;
    var m = 10;
    var tab_w;
    if (document.documentElement.clientWidth > 1200) {
        if (i == 6) {
            var d = 1;
            tab_w = w / i - m - d;
        } else if (i == 5) {
            var d = 2;
            tab_w = w / i - m + d;
        } else if (i == 4 | i == 3) {
            var d = 3;
            tab_w = w / i - m + d;
        } else if (i == 2) {
            var d = 5;
            tab_w = w / i - m + d;
        } else {
            tab_w = w / i - m;
        }
    } else {
        tab_w = w / i - m;
    }

    $('.sales .nav-tabs > li').each(function () {
        $(this).css('min-width', Math.floor(tab_w));
    });
};

$(function () {
    function reposition() {
        var modal = $(this),
            dialog = modal.find('.modal-dialog');
        modal.css('display', 'block');

        // Dividing by two centers the modal exactly, but dividing by three
        // or four works better for larger screens.
        dialog.css("margin-top", Math.max(0, ($(window).height() - dialog.height()) / 2));
    }

    // Reposition when a modal is shown
    $('.modal').on('show.bs.modal', reposition);
    // Reposition when the window is resized
    $(window).on('resize', function () {
        $('.modal:visible').each(reposition);
    });
});

var ZoomFix = function () {
    var bw = window.devicePixelRatio;
    var w = bw.toFixed(2);
    $('.steps li.active').css('border-right-color', '#ccc !important');
    $('.steps li').css('border-right-color', '#e7e7e7 !important');
    if (w == 1.25) {
        $('.step-3, .step-4').css('border-right', '1px solid transparent');
        $('.step-1, .step-2').css('border-right', 'none');
        $('.step-1, .step-2, .step-3, .step-4').css('border-right', '1px solid transparent');
    } else if (w == 1.50) {
        $('.step-2, .step-3').css('border-right', '1px solid transparent');
        $('.step-1, .step-4').css('border-right', 'none');
    } else if (w == 1.58) {
        $('.step-1, .step-2, .step-3, .step-4').css('border-right', '1px solid transparent');
    } else if (w == 1.62) {
        $('.step-3').css('border-right', '1px solid transparent');
        $('.step-1, .step-2, .step-4').css('border-right', 'none');
    } else if (w == 1.71) {
        $('.step-2, .step-3, .step-4').css('border-right', '1px solid transparent');
        $('.step-1').css('border-right', 'none');
    } else if (w == 1.82) {
        $('.step-1, .step-2, .step-3, .step-4').css('border-right', '1px solid transparent');
    } else if (w == 1.88) {
        $('.step-2, .step-4').css('border-right', '1px solid transparent');
        $('.step-1, .step-3').css('border-right', 'none');
    } else if (w == 2.07) {
        $('.step-4').css('border-right', '1px solid transparent');
        $('.step-1, .step-2, .step-3').css('border-right', 'none');
    } else if (w == 2.22) {
        $('.step-1, .step-2, .step-3, .step-4').css('border-right', '1px solid transparent');
    } else if (w == 2.31) {
        $('.step-1, .step-2, .step-3, .step-4').css('border-right', '1px solid transparent');
        $('.step-1').css('border-right', 'none');
    } else if (w == 2.50) {
        if ($.browser.mozilla) {
            $('.step-1, .step-2, .step-4').css('border-right', '1px solid transparent');
        }
        $('.step-3, .step-4').css('border-right', '1px solid transparent');
        if ($.browser.webkit) {
            $('.step-1, .step-2').css('border-right', 'none');
        }
    } else if (w == 2.61) {
        $('.step-2, .step-4').css('border-right', '1px solid transparent');
        $('.step-1, .step-3').css('border-right', 'none');
    } else if (w == 2.73) {
        $('.step-1, .step-2, .step-3, .step-4').css('border-right', '1px solid transparent');
    } else if (w == 2.86) {
        $('.step-1, .step-2, .step-3, .step-4').css('border-right', '1px solid transparent');
    } else {
        $('.step-1, .step-2, .step-3, .step-4').css('border-right', 'none');
    }
};

jQuery(document).ready(function ($) {
    newHeight();
    ZoomFix();
    googleMapsRoute();

    var currentTime = new Date()
    //For anmietzeit and rueckgabezeit
    $("#anmietzeit").select2({
        minimumResultsForSearch: 1,
        dropdownCssClass: ':all:',
        width: '126px',
    });
    $("#anmietort_dd").select2({
        dropdownCssClass: ':all:',
        width: '100%',
    });
    $("#rueckgabeort_dd").select2({
        dropdownCssClass: ':all:',
        width: '100%',
    });

    $(document).keypress(function (e) {
        if (e.which == 13) {
            if ($('#anmietzeit').data('select2').isOpen())
                $('#anmietzeit').select2("close");
            if ($('#rueckgabezeit').data('select2').isOpen())
                $('#rueckgabezeit').select2("close");
        }
    });


    $("#change-data #anmietzeit").select2({
        minimumResultsForSearch: Infinity,
        dropdownCssClass: ':all:',
        width: '121px',
    });
    $("#anmietzeit").on("select2:close", function (e) {
        var date = $('#anmietdatum').datepicker('getDate');
        if (date) {
            var rueckgabedate = (date.getTime() + 1000 * 60 * 60 * 24 * 1);

            $('#rueckgabedatum').datepicker('setDate', new Date(rueckgabedate));
            $('#rueckgabezeit').val($(this).val()).trigger("change");

            /* workarround */
            var selectHightlight = false;
            $("#rueckgabezeit").select2("open");
            $("#rueckgabezeit").select2("close");
            var selectHightlight = true;

            setTimeout(function () {
                $('#rueckgabedatum').focus();
            }, 50);
        }
    });

    $("#home #anmietzeit").on("select2:open", function () {
        // set border
        if (selectHightlight == true)
            $(this).parent("div").addClass("dd-active");
    });

    $("#home #anmietzeit").on("select2:close", function () {
        // set border
        if (selectHightlight == true)
            $(this).parent("div").removeClass("dd-active");
    });

    /* workarround */
    var selectHightlight = false;
    $("#anmietzeit").select2("open");
    $("#anmietzeit").select2("close");

    $("#rueckgabezeit").select2({
        minimumResultsForSearch: Infinity,
        dropdownCssClass: ':all:',
        width: '126px',
    });

    $("#rueckgabezeit").on("select2:close", function (e) {
        // Pulse-Animation für bessere Sichtbarkeit hinzufügen
        var $searchBtn = $('#searchBtn');
        $searchBtn.addClass('pulse-ready');

        // Animation nach 4.5 Sekunden entfernen (3 Wiederholungen à 1.5s)
        setTimeout(function() {
            $searchBtn.removeClass('pulse-ready');
        }, 4500);

        // Fokus setzen für Tastaturnavigation
        $searchBtn.focus();
    });

    $("#change-data #rueckgabezeit").select2({
        minimumResultsForSearch: Infinity,
        dropdownCssClass: ':all:',
        width: '121px',
    });

    $("#home #rueckgabezeit").on("select2:open", function () {
        // set border
        if (selectHightlight == true)
            $(this).parent("div").addClass("dd-active");
    });

    $("#home #rueckgabezeit").on("select2:close", function () {
        // set border
        if (selectHightlight == true)
            $(this).parent("div").removeClass("dd-active");
    });

    /* workarround */
    $("#rueckgabezeit").select2("open");
    $("#rueckgabezeit").select2("close");
    var selectHightlight = true;

    // Initialize Select2 for Nutzfahrzeuge time fields
    $("#nutz-anmietzeit").select2({
        minimumResultsForSearch: 1,
        dropdownCssClass: ':all:',
        width: '100%',
    });

    $("#nutz-rueckgabezeit").select2({
        minimumResultsForSearch: Infinity,
        dropdownCssClass: ':all:',
        width: '100%',
    });

    // Auto-advance logic for Nutzfahrzeuge form (similar to main form)
    $("#nutz-anmietzeit").on("select2:close", function (e) {
        var date = $('#nutz-anmietdatum').datepicker('getDate');
        if (date) {
            var rueckgabedate = (date.getTime() + 1000 * 60 * 60 * 24 * 1);
            $('#nutz-rueckgabedatum').datepicker('setDate', new Date(rueckgabedate));
            $('#nutz-rueckgabezeit').val($(this).val()).trigger('change');
            $('#nutz-rueckgabedatum').focus();
        }
    });

    $("#nutz-rueckgabezeit").on("select2:close", function (e) {
        // Pulse-Animation für bessere Sichtbarkeit hinzufügen
        var $searchBtn = $('#nutz-search-desktop');
        $searchBtn.addClass('pulse-ready');
        setTimeout(function() {
            $searchBtn.removeClass('pulse-ready');
        }, 4500);
        $searchBtn.focus();
    });

    $("#umkreis").select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        allowClear: true,
        placeholder: $("#umkreis").data('placeholder') || 'Umkreis, km'
    });

    // X-Button persistent für #umkreis (LKW-Tab) - searchMask kann 50km festhalten nach vorheriger Suche
    var UMKREIS_CLEARED_KEY = 'umkreisCleared';
    try {
        if (window.localStorage && localStorage.getItem(UMKREIS_CLEARED_KEY) === '1') {
            $("#umkreis").val('').trigger('change');
        }
    } catch (e) {}

    $("#umkreis").on("select2:unselect", function () {
        try { if (window.localStorage) { localStorage.setItem(UMKREIS_CLEARED_KEY, '1'); } } catch (e) {}
    });

    $("#umkreis").on("select2:select", function () {
        try { if (window.localStorage) { localStorage.removeItem(UMKREIS_CLEARED_KEY); } } catch (e) {}
        // Markiere als explizite User-Wahl, damit Stadt-Wechsel den Wert nicht überschreibt
        $(this).data('user-set', true);
        $(this).removeData('auto-radius');
    });

    $("#umkreis").on("select2:clear", function () {
        $(this).val('').trigger('change');
        $(this).removeData('auto-radius');
        $(this).removeData('user-set');
        try { if (window.localStorage) { localStorage.setItem(UMKREIS_CLEARED_KEY, '1'); } } catch (e) {}
    });

    $("#umkreis").on("change", function () {
        if (!$(this).val()) {
            $(this).removeData('auto-radius');
            $(this).removeData('user-set');
        }
    });

    $("#umkreis").on("select2:open", function () {
        $(this).parent("div").addClass("dd-active");
    });

    $("#umkreis").on("select2:close", function () {
        $(this).parent("div").removeClass("dd-active");
    });

    // Select2 für Nutzfahrzeuge-Tab (identisch zu #umkreis)
    $("#umkreisNutz").select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        allowClear: true,
        placeholder: $("#umkreisNutz").data('placeholder') || 'Umkreis, km'
    });

    $("#umkreisNutz").on("select2:clear select2:unselect", function () {
        $(this).val('').trigger('change');
        $(this).removeData('auto-radius');
        $(this).removeData('user-set');
    });

    $("#umkreisNutz").on("select2:select", function () {
        $(this).data('user-set', true);
        $(this).removeData('auto-radius');
    });

    $("#umkreisNutz").on("change", function () {
        if (!$(this).val()) {
            $(this).removeData('auto-radius');
            $(this).removeData('user-set');
        }
    });

    $("#umkreisNutz").on("select2:open", function () {
        $(this).parent("div").addClass("dd-active");
    });

    $("#umkreisNutz").on("select2:close", function () {
        $(this).parent("div").removeClass("dd-active");
    });
    window.setTimeout(function () {
        $("#tab-lkw").addClass("loaded")
    }, 2000);
    //For anmietzeit and rueckgabezeit - end -

    /*set focus back to abholung */
    var SearchInput = $("#anmietort");
    if (SearchInput.length) {
        SearchInput.focus();
        SearchInput[0].setSelectionRange(100, 100);
    }


    $('#plz').on('keypress', function (e) {
        return e.metaKey || // cmd/ctrl
            e.which <= 0 || // arrow keys
            e.which == 8 || // delete key
            /[0-9]/.test(String.fromCharCode(e.which)); // numbers
    });

    $('.selectbox').selectbox({
        classToggleOpen: 'icon-toggle-open',
        classToggle: 'icon-toggle',
    });

    SaleTabs();
    if (document.documentElement.clientWidth > 992) {
        sameHeight();
    }

    /*$('.sales .nav-tabs > li > a').hover( function() {
     $(this).next().show();
     }, function() {
     $(this).next().hide();
     });*/

    $('#m-login').click(function (event) {
        $('a[aria-controls=bynumber]').tab('show');
        $('.forgot-id-m').hide();
        $('.login-m').show();
        $('.forgot-pw-m').hide();

        $('.default-view').hide();
        $('.login-view').show();
        $('.sidebar').css('background', 'transparent');

        event.stopPropagation();
    });

    $('#v-login').click(function (event) {
        $('.login-v').show();
        $('.forgot-pw-v').hide();
        $('.forgot-id-v').hide();

        $('.default-view').hide();
        $('.vermieter-view').show();
        $('.sidebar').css('background', 'transparent');
        event.stopPropagation();
    });

    $('a[aria-controls=bynumber]').click(function () {
        var rel = $(this).attr('aria-expanded');
        if (rel == 'true') {
            $('.login-view').hide();
            $('.default-view').show();
            $('.tempmsg').hide();
            $('.sidebar').css('background', 'rgba(0, 0, 0, .5)');
        } else {
            $(this).tab('show');
        }
    });

    $('a[aria-controls=byaccount]').click(function () {
        var rel = $(this).attr('aria-expanded');
        if (rel == 'true') {
            $('.login-view').hide();
            $('.default-view').show();
            $('.tempmsg').hide();
            $('.sidebar').css('background', 'rgba(0, 0, 0, .5)');
        } else {
            $(this).tab('show');
        }
    });

    $('a[aria-controls=byvermieter]').click(function () {
        var rel = $(this).attr('aria-expanded');
        if (rel == 'true') {
            $('.vermieter-view').hide();
            $('.default-view').show();
            $('.tempmsg').hide();
            $('.sidebar').css('background', 'rgba(0, 0, 0, .5)');
        } else {
            $(this).tab('show');
        }
    });

    $('html').click(function () {
        $('.views:visible').hide(1, function () {
            $('.default-view').show();
            $('.tempmsg').hide();
            $('.sidebar').css('background', 'rgba(0, 0, 0, .5)');
        });
    });

    $('.views').click(function (event) {
        event.stopPropagation();
    });

    $('.btn-close').click(function () {
        var rel = $(this).attr('data-rel');
        if (rel == 'sub-menu-m') {
            var e = $(this).attr('data-id');
            $('.' + e).hide();
            $('.login-m').show();
        } else if (rel == 'sub-menu-v') {
            var e = $(this).attr('data-id');
            $('.' + e).hide();
            $('.login-v').show();
        } else {
            var e = $(this).attr('data-id');
            $('.' + e).hide();
            $('.default-view').show();
            $('.tempmsg').hide();
            $('.sidebar').css('background', 'rgba(0, 0, 0, .5)');
        }
    });
    $('#s-optimize').click(function () {
        $('.search-data .default').hide();
        $('.search-data .edit').show();
    });
    $('#s-optimize-t').click(function () {
        $('.search-data .default-t').hide();
        $('.search-data .edit').show();
    });

    $('#forgot-pw-m').click(function () {
        $('.login-m').hide();
        $('.forgot-pw-m').show();
    });

    $('#forgot-pw-m2').click(function () {
        $('.login-m').hide();
        $('.forgot-pw-m2').show();
    });

    $('#forgot-id-m').click(function () {
        $('.forgot-id-m').toggle();
    });

    $('#forgot-pw-v,#forgot-pw-v2').click(function () {
        $('.login-v').hide();
        $('.forgot-pw-v').show();
    });

    $('#vermieter-tab #forgot-pw-vermieter').click(function () {
        $('#vermieter-login-container').hide();
        $('#vermieter-pwd-container .errormsg').hide();
        $('#vermieter-pwd-container .succesmsg').hide();
        $('#vermieter-pwd-container').show();
        return false;
    });

    $('#vermieter-tab #vermieter-pwd-back').click(function () {
        $('#vermieter-pwd-container').hide();
        $('#vermieter-pwd-container .errormsg').hide();
        $('#vermieter-pwd-container .succesmsg').hide();
        $('#vermieter-login-container').show();
        return false;
    });

    $('#forgot-id-v').click(function () {
        $('.forgot-id-v').toggle();
    });

    /**
     * Die Button-Funktionen später richtig schreiben - START
     */
    $('#sub-menu').click(function () {
        var e = $(this).attr('data-rel');
        $('.' + e).show();
    });
    $('.bubble .close').click(function () {
        $(this).parent().hide();
    });
    $('.bubble .btn-green').click(function () {
        $(this).parent().hide();
    });
    /**
     * Die Button-Funktionen später richtig schreiben - ENDE
     */

    /**
     * Die Modal-Funktionen später richtig schreiben - START
     */
    /*
     $('#searchBtn').click(function() {
     $('#search-ok').modal('show');
     });

     $('#reg-mail').click(function() {
     $('#register-msg').modal('show');
     });
     */
    $('#tell-button').click(function () {
        if (validateEmail($('#tell input[name="email"]').val())) {
            $.ajax({
                method: "POST",
                url: "/home/handleAjax/weiterempfehlung",
                data: {servicecode: $('#tell input[name="service_code"]').val(), orderid: $('#tell input[name="order_id"]').val(), email: $('#tell input[name="email"]').val()},
                success: function (data, status, xhr) {
                    $('#tell .alert-success').show();
                    $('#tell .alert-error').hide();
                    $('#tell-button').hide();
                    $('#tell-button-done').show();
                },
            });
        }
        else {
            $('#tell .alert-error').show();
            $('#tell .alert-success').hide();
        }

    });

    $('#newsletter_button').click(function () {
        if (validateEmail($('#newsletter input[name="email"]').val())) {
            $.ajax({
                method: "POST",
                url: "/home/handleAjax/newsletter",
                data: {email: $('#newsletter input[name="email"]').val()},
                success: function (data, status, xhr) {
                    $('#newsletter .errormsg').hide();
                    if (data == "-1") {
                        $('#newsletter .infomsg').show();
                        $('#newsletter .succesmsg').hide();
                    }
                    if (data == "1") {
                        $('#newsletter .succesmsg').show();
                        $('#newsletter .infomsg').hide();
                    }

                    $('#newsletter input[name="email"]').val("");
                },
            });
        }
        else {
            $('#newsletter .errormsg').show();
            $('#newsletter .succesmsg').hide();
            $('#newsletter .infomsg').hide();
        }
        return false;
    });

    $('#newsletter_button2').click(function () {
        if (validateEmail($('#newsletter2 input[name="email"]').val())) {
            $.ajax({
                method: "POST",
                url: "/home/handleAjax/newsletter",
                data: {email: $('#newsletter2 input[name="email"]').val()},
                success: function (data, status, xhr) {
                    $('#newsletter2 .errormsg').hide();
                    if (data == "-1") {
                        $('#newsletter2 .infomsg').show();
                        $('#newsletter2 .succesmsg').hide();
                    }
                    if (data == "1") {
                        $('#newsletter2 .succesmsg').show();
                        $('#newsletter2 .infomsg').hide();
                    }

                    $('#newsletter2 input[name="email"]').val("");
                },
            });
        }
        else {
            $('#newsletter2 .errormsg').show();
            $('#newsletter2 .succesmsg').hide();
            $('#newsletter2 .infomsg').hide();
        }
        return false;
    });

    $('#kunde-passwort-vergessen').click(function () {
        if (validateEmail($('#forgot-pw-m-container input[name="email"]').val())) {
            $.ajax({
                method: "POST",
                url: "/home/handleAjax/customer-pwd",
                data: {email: $('#forgot-pw-m-container input[name="email"]').val()},
                success: function (data, status, xhr) {
                    $('#forgot-pw-m-container .errormsg').hide();
                    $('#forgot-pw-m-container .succesmsg').show();
                    $('#forgot-pw-m-container input[name="email"]').val("");
                },
                error: function () {
                    $('#forgot-pw-m-container .errormsg').hide();
                    $('#forgot-pw-m-container .succesmsg').show();
                },
            });
        }
        else {
            $('#forgot-pw-m-container .errormsg').show();
            $('#forgot-pw-m-container .succesmsg').hide();
        }
        return false;
    });

    $('#kunde-passwort-vergessen-tablet').click(function () {
        if (validateEmail($('#forgot-pw-m-container-tablet input[name="email"]').val())) {
            $.ajax({
                method: "POST",
                url: "/home/handleAjax/customer-pwd",
                data: {email: $('#forgot-pw-m-container-tablet input[name="email"]').val()},
                success: function (data, status, xhr) {
                    $('#forgot-pw-m-container-tablet .errormsg').hide();
                    $('#forgot-pw-m-container-tablet .succesmsg').show();
                    $('#forgot-pw-m-container-tablet input[name="email"]').val("");
                },
                error: function () {
                    $('#forgot-pw-m-container-tablet .errormsg').hide();
                    $('#forgot-pw-m-container-tablet .succesmsg').show();
                },
            });
        }
        else {
            $('#forgot-pw-m-container-tablet .errormsg').show();
            $('#forgot-pw-m-container-tablet .succesmsg').hide();
        }
        return false;
    });

    $('#kunde-passwort-vergessen2').click(function () {
        if (validateEmail($('#forgot-pw-m-container input[name="email"]').val())) {
            $.ajax({
                method: "POST",
                url: "/home/handleAjax/customer-pwd",
                data: {email: $('#forgot-pw-m-container input[name="email"]').val()},
                success: function (data, status, xhr) {
                    $('#forgot-pw-m-container .errormsg').hide();
                    if (data == "-1") {
                        $('#forgot-pw-m-container .errormsg').show();
                        $('#forgot-pw-m-container .succesmsg').hide();
                    }
                    if (data == "1") {
                        $('#customer-login-container').show();
                        $('#forgot-pw-m-container').hide();
                        $('#customer-login-container .succesmsg').show();
                        $('#forgot-pw-m-container .infomsg').hide();
                    }

                    $('#forgot-pw-m-container input[name="email"]').val("");
                },
            });
        }
        else {
            $('#forgot-pw-m-container .errormsg').show();
            $('#forgot-pw-m-container .succesmsg').hide();
        }
        return false;
    });

    $('#anbieter-passwort-vergessen').click(function () {
        if (validateEmail($('#forgot-pw-v-container input[name="email"]').val())) {
            $.ajax({
                method: "POST",
                url: "/home/handleAjax/vermieter-pwd",
                data: {email: $('#forgot-pw-v-container input[name="email"]').val()},
                success: function (data, status, xhr) {
                    $('#forgot-pw-v-container .errormsg').hide();
                    if (data == "-1") {
                        $('#forgot-pw-v-container .errormsg').show();
                        $('#forgot-pw-v-container .succesmsg').hide();
                    }
                    if (data == "1") {
                        $('#forgot-pw-v-container .succesmsg').show();
                    }

                    $('#forgot-pw-v-container input[name="email"]').val("");
                },
            });
        }
        else {
            $('#forgot-pw-v-container .errormsg').show();
            $('#forgot-pw-v-container .succesmsg').hide();
        }
        return false;
    });

    function sendVermieterPasswordReset() {
        if (validateEmail($('#vermieter-pwd-container input[name="email"]').val())) {
            $.ajax({
                method: "POST",
                url: "/home/handleAjax/vermieter-pwd",
                data: {email: $('#vermieter-pwd-container input[name="email"]').val()},
                success: function (data, status, xhr) {
                    $('#vermieter-pwd-container .errormsg').hide();
                    if (data == "-1") {
                        $('#vermieter-pwd-container .errormsg').show();
                        $('#vermieter-pwd-container .succesmsg').hide();
                    }
                    if (data == "1") {
                        $('#vermieter-pwd-container .succesmsg').show();
                    }

                    $('#vermieter-pwd-container input[name="email"]').val("");
                },
                error: function () {
                    $('#vermieter-pwd-container .errormsg').show();
                    $('#vermieter-pwd-container .succesmsg').hide();
                },
            });
        }
        else {
            $('#vermieter-pwd-container .errormsg').show();
            $('#vermieter-pwd-container .succesmsg').hide();
        }
    }

    $('#vermieter-tab #login-vermieter-passwort-vergessen').click(function () {
        sendVermieterPasswordReset();
        return false;
    });

    $('#vermieter-tab #vermieter-pwd-form').submit(function () {
        sendVermieterPasswordReset();
        return false;
    });

    $('.pickup-return-diff').click(function () {
        $('#pickup-retun-diff').modal('show');
    });
    $('.pickup-return-same').click(function () {
        $('#pickup-retun-same').modal('show');
    });
    $('.change-data').click(function () {
        $('#change-data').modal('show');
    });
    $('#confirm-change-data').click(function () {
        // Suchergebnisse-URL aus Step-Navigation (Breadcrumb) auslesen
        var searchUrl = $('.step-1 a').attr('href');
        if (searchUrl) {
            window.location.href = searchUrl + '?edit=1';
        } else {
            window.location.href = '/suchergebnisse.html?edit=1';
        }
    });
    /**
     * Die Modal-Funktionen später richtig schreiben - ENDE
     */

    $('input[name=vehicleclass]').change(function () {
        var vehicle = $('input[name=vehicleclass]:checked').val();
        $('.sub-group').hide();
        $('#sub-group-' + vehicle).show();
        $('#sub-group-t' + vehicle).show();
    });
    $('input[name=vehicleclass]').trigger('change');

    /*
    $('input#diebstahl,input#vollkasko,input#vollkaskoDiebstahl').change(function () {
        var vehicle2 = $(this).val();
        if ($(this).is(':checked')) {
            $('#sub-group-' + vehicle2).show();
            $('#sub-group-t' + vehicle2).show();
        } else {
            $('#sub-group-' + vehicle2).hide();
            $('#sub-group-t' + vehicle2).hide();
        }
    });
    $('input#diebstahl,input#vollkasko,input#vollkaskoDiebstahl').trigger('change');
*/


    $('input[name=fon]').change(function () {
        var fon = $('input[name=fon]:checked').val();
        if (fon == 'mobil') {
            $('#mobil').show();
            $('#mobil input').each(function () {
                $(this).prop('disabled', false);
            });
            $('#fon').hide();
            $('#fon input').each(function () {
                //$(this).prop('disabled', 'disabled');
            });
        } else {
            $('#fon').show();
            $('#fon input').each(function () {
                $(this).prop('disabled', false);
            });
            $('#mobil').hide();
            $('#mobil input').each(function () {
                //$(this).prop('disabled', 'disabled');
            });
        }
    });
    $('input[name=fon]').trigger('change');

    $('#searchForm input[type=checkbox]').change(function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('checked');
        } else {
            $(this).parent().removeClass('checked');
        }
    });
    $('#searchForm input[type=checkbox]').trigger('change');

    $('#filtering input[type=checkbox]').change(function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('checked');
        } else {
            $(this).parent().removeClass('checked');
        }
    });
    $('#filtering input[type=checkbox]').trigger('change');

    $('#filtering input:radio').click(function () {
        $('#filtering input:radio[name=' + $(this).attr('name') + ']').parent().removeClass('checked');
        $(this).parent().addClass('checked');
    });
    $('#filtering input:radio:checked').parent().addClass('checked');

    $('.extras input:checkbox').change(function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('checked');
            if ($(this).parent().parent().has('span')) {
                $(this).parent().parent().find('select').prop('disabled', false);
            }
        } else {
            $(this).parent().removeClass('checked');
            if ($(this).parent().parent().has('span')) {
                $(this).parent().parent().find('select').prop('disabled', 'disabled');
            }
        }
    });
    $('.extras input:checkbox').trigger('change');

    $('.extras input:radio').click(function () {
        $('.extras input:radio[data-type=' + $(this).data('type') + ']').parent().removeClass('checked');
        $(this).parent().addClass('checked');
    });
    $('.extras input:radio:checked').parent().addClass('checked');

    $('.kundendaten input:checkbox').change(function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('checked');
        } else {
            $(this).parent().removeClass('checked');
        }
    });
    $('.kundendaten input:checkbox').trigger('change');

    $('.votes').click(function () {
        var id = $(this).attr('data-detail');
        var target_tab = $(this).attr('data-tab');

        if ($('#' + id).hasClass('in')) {
            $('#' + id + ' a[href="#' + target_tab + '"]').tab('show');
        } else {
            $('#' + id).collapse('show');
            $('#' + id).on('shown.bs.collapse', function () {
                $('#' + id + ' a[href="#' + target_tab + '"]').tab('show');
            });
        }
    });

    /*$('input').blur(function()
     {
     if (!$(this).val()) {
     $(this).css('background-color', '#e7e7e7');
     } else {
     $(this).css('background-color', '#fff');
     }
     });
     $('input').trigger('blur');

     $('select').change(function() {
     if ($(this).val() === "") {
     $(this).css('background-color', '#e7e7e7');
     } else {
     $(this).css('background-color', '#fff');
     }
     });
     $('select').trigger('change');*/

    $('.car-details-collapse').on('shown.bs.collapse', function () {
        var panel = $(this).find('.in');
        $('html, body').animate({
            scrollTop: panel.offset().top + -40
        }, 500);
    });

    $('.car-details-collapse').on('hidden.bs.collapse', function () {
        var panel = $(this).prevAll().parents('.panel-result');
        $('html, body').animate({
            scrollTop: panel.offset().top + -5
        }, 500);
    });

    var options = {
        closeText: "Schließen",
        prevText: "&#x3C;Zurück",
        nextText: "Vor&#x3E;",
        currentText: "Heute",
        monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
        dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        weekHeader: "KW",
        dateFormat: "D, dd.mm.yy",
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: "",
    };

    $.datepicker.setDefaults(options);

    $('#anmietdatum').datepicker({
        numberOfMonths: 2,
        defaultDate: "",
        minDate: 0,
        beforeShowDay: function(date) {
            if (typeof GermanHolidays !== 'undefined') {
                return GermanHolidays.beforeShowDay(date);
            }
            return [true, '', ''];
        },
        onSelect: function (selectedDate) {
            // Im Search-Edit-Modal: nativen Select fokussieren statt Select2
            if ($(this).closest('#search-edit-modal').length) {
                // Rückgabedatum automatisch auf +1 Tag setzen
                var date = $(this).datepicker('getDate');
                if (date) {
                    var nextDay = new Date(date.getTime() + 1000 * 60 * 60 * 24);
                    $('#rueckgabedatum').datepicker('setDate', nextDay);
                }
                $('#anmietzeit').focus();
            } else {
                $('#anmietzeit').select2('focus');
                $("#anmietzeit").select2("open");
            }
            // Check for holiday warning
            if (typeof GermanHolidays !== 'undefined') {
                var date = $(this).datepicker('getDate');
                var holiday = GermanHolidays.getHoliday(date);
                showHolidayWarning('#anmietdatum', holiday);
            }
            // Trigger dateSelected Event für OpeningHoursValidation (Sonntagshinweis)
            $(document).trigger('dateSelected', [$(this).datepicker('getDate')]);
        }
    }).bind("keydown", function (e) {
        if (e.which == 13) {
            $(this).blur()
            $(this).datepicker('hide');
        }
    });


    $('#rueckgabedatum').datepicker({
        numberOfMonths: 2,
        defaultDate: "+1d",
        minDate: 0,
        // No holiday warnings for return dates - return is typically 24/7 via key drop-off
        onSelect: function (selectedDate) {
            // Im Search-Edit-Modal: nativen Select fokussieren statt Select2
            if ($(this).closest('#search-edit-modal').length) {
                $('#rueckgabezeit').focus();
            } else {
                $('#rueckgabezeit').select2('focus');
                $('#rueckgabezeit').select2('open');
            }
        }
    }).bind("keydown", function (e) {
        if (e.which == 13) {
            $(this).blur();
            $(this).datepicker('hide');
        }
    });

    // Datepicker for Nutzfahrzeuge form
    $('#nutz-anmietdatum').datepicker({
        numberOfMonths: 2,
        defaultDate: "",
        minDate: 0,
        beforeShowDay: function(date) {
            if (typeof GermanHolidays !== 'undefined') {
                return GermanHolidays.beforeShowDay(date);
            }
            return [true, '', ''];
        },
        onSelect: function (selectedDate) {
            $('#nutz-anmietzeit').select2('focus');
            $("#nutz-anmietzeit").select2("open");
            // Check for holiday warning
            if (typeof GermanHolidays !== 'undefined') {
                var date = $(this).datepicker('getDate');
                var holiday = GermanHolidays.getHoliday(date);
                showHolidayWarning('#nutz-anmietdatum', holiday);
            }
            // Trigger dateSelected Event für OpeningHoursValidation (Sonntagshinweis)
            $(document).trigger('dateSelected', [$(this).datepicker('getDate')]);
        }
    }).bind("keydown", function (e) {
        if (e.which == 13) {
            $(this).blur();
            $(this).datepicker('hide');
        }
    });

    $('#nutz-rueckgabedatum').datepicker({
        numberOfMonths: 2,
        defaultDate: "+1d",
        minDate: 0,
        // No holiday warnings for return dates - return is typically 24/7 via key drop-off
        onSelect: function (selectedDate) {
            $('#nutz-rueckgabezeit').select2('focus');
            $('#nutz-rueckgabezeit').select2('open');
        }
    }).bind("keydown", function (e) {
        if (e.which == 13) {
            $(this).blur();
            $(this).datepicker('hide');
        }
    });

    // Birthday fields - manual input enabled, datepicker disabled
    // Users can type directly in format TT.MM.JJJJ
    /*
    $('#geburtsdatum').datepicker({
        numberOfMonths: 1,
        dateFormat: "dd.mm.yy",
        changeMonth: true,
        changeYear: true,
        defaultDate: "-25y",
        yearRange: (currentTime.getFullYear() - 80) + ":" + (currentTime.getFullYear() - 17)
    });

    $('#geburtsdatum-po').datepicker({
        numberOfMonths: 1,
        dateFormat: "dd.mm.yy",
        changeMonth: true,
        changeYear: true,
        defaultDate: "-25y",
        yearRange: (currentTime.getFullYear() - 80) + ":" + (currentTime.getFullYear() - 17)
    });
    */

    // Birthday field input mask for TT.MM.JJJJ format
    function applyBirthdayMask(input) {
        $(input).on('input', function(e) {
            var value = this.value.replace(/\D/g, ''); // Remove non-digits
            var formatted = '';

            if (value.length > 0) {
                // Day (max 31)
                var day = value.substring(0, 2);
                if (day.length === 2) {
                    var dayNum = parseInt(day, 10);
                    if (dayNum > 31) day = '31';
                    if (dayNum === 0) day = '01';
                }
                formatted = day;
            }
            if (value.length > 2) {
                // Month (max 12)
                var month = value.substring(2, 4);
                if (month.length === 2) {
                    var monthNum = parseInt(month, 10);
                    if (monthNum > 12) month = '12';
                    if (monthNum === 0) month = '01';
                }
                formatted += '.' + month;
            }
            if (value.length > 4) {
                // Year (4 digits)
                formatted += '.' + value.substring(4, 8);
            }

            this.value = formatted;
        });

        // Prevent non-numeric input except dots
        $(input).on('keypress', function(e) {
            var charCode = e.which || e.keyCode;
            // Allow: backspace, delete, tab, escape, enter, dots
            if (charCode === 8 || charCode === 46 || charCode === 9 ||
                charCode === 27 || charCode === 13 || charCode === 190) {
                return true;
            }
            // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
            if (e.ctrlKey || e.metaKey) {
                return true;
            }
            // Allow: 0-9
            if (charCode >= 48 && charCode <= 57) {
                return true;
            }
            e.preventDefault();
            return false;
        });
    }

    // Apply birthday mask to desktop birthday fields
    applyBirthdayMask('#geburtsdatum');
    applyBirthdayMask('#geburtsdatum-po');

    // Close datepicker when clicking outside - use mousedown which fires before datepicker's click handler
    $(document).on('mousedown', function(e) {
        var $target = $(e.target);
        // Only hide if click is outside the datepicker widget AND outside the input fields
        if (!$target.closest('.ui-datepicker').length &&
            !$target.closest('.ui-datepicker-trigger').length &&
            !$target.hasClass('hasDatepicker') &&
            !$target.is('input[id$="datum"]')) {
            // Use setTimeout to allow datepicker's own handlers to run first
            setTimeout(function() {
                $('#anmietdatum').datepicker('hide');
                $('#rueckgabedatum').datepicker('hide');
            }, 10);
        }
    });

    /* OLD AUTOCOMPLETE DISABLED - replaced by city-autocomplete.js plugin
    $('#anmietort').autocomplete({
        source: "/home/handleAjax/city",
        minLength: 1,
        open: function () {
            var width = $('#anmietort').data("width");
            if (width > 0)
                $('.ui-autocomplete').css('width', $('#anmietort').data("width"));
        },
        select: function (event, ui) {
            $('#anmietort').val(ui.item.cityname);
            $("#anmietort").parent('div').removeClass('has-error');
            $('<style>.frontpage-header .anmietort:before,#change-data .form-group .anmietort:before {content:"\\f041";color: #4b7600;}</style>').appendTo('head');
            $('#anmietdatum').focus();
        }
    });

    jQuery.ui.autocomplete.prototype._resizeMenu = function () {
        var ul = this.menu.element;
        ul.outerWidth(this.element.outerWidth());
    }

    $('#rueckgabeort').autocomplete({
        source: "/home/handleAjax/city",
        minLength: 1,
        select: function (event, ui) {
            $('#rueckgabetort').val(ui.item.cityname);
            $('#rueckgabedatum').focus();
        }
    });
    END OLD AUTOCOMPLETE */

    // Search Form Validation - Enable/Disable button based on required fields
    function validateSearchFormDesktop() {
        // 1. Check location (Anmietort or anmietort_dd dropdown or PLZ+Umkreis)
        var anmietort = $('#anmietort').val();
        var anmietortDD = $('#anmietort_dd').val();
        var plz = $('#plz').val();
        var umkreis = $('#umkreis').val();
        var hasLocation = anmietort || anmietortDD || (plz && umkreis);

        // 2. Check date (must be today or in the future)
        var anmietdatum = $('#anmietdatum').val();
        var hasValidDate = false;

        if (anmietdatum) {
            // Format can be "DD.MM.YYYY" or "Di, DD.MM.YYYY" (with weekday prefix)
            var dateMatch = anmietdatum.match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/);
            if (dateMatch) {
                var day = parseInt(dateMatch[1]);
                var month = parseInt(dateMatch[2]) - 1;
                var year = parseInt(dateMatch[3]);
                var inputDate = new Date(year, month, day);
                var today = new Date();
                today.setHours(0, 0, 0, 0);
                hasValidDate = (inputDate >= today);
            }
        }

        // 3. Check if opening hours warning is active
        var hasOpeningHoursWarning = window.OpeningHoursValidation && window.OpeningHoursValidation.warningActive;

        // 4. Enable/disable button
        var button = $('#searchBtn');

        if (hasLocation && hasValidDate && !hasOpeningHoursWarning) {
            button.prop('disabled', false).attr('title', '');
        } else {
            var msg = [];
            if (!hasLocation) msg.push('Abholort');
            if (!hasValidDate) msg.push('gueltiges Abholdatum');
            if (hasOpeningHoursWarning) msg.push('anderes Datum (Vermieter geschlossen)');
            button.prop('disabled', true).attr('title', 'Bitte ' + msg.join(' und ') + ' eingeben');
        }
    }
    // Expose for opening-hours-validation.js re-trigger
    window.validateSearchFormDesktop = validateSearchFormDesktop;

    // Initial validation on page load
    setTimeout(function() {
        validateSearchFormDesktop();
    }, 100);

    // Event listeners for validation
    $('#anmietort, #anmietort_dd, #anmietdatum, #plz, #umkreis').on('change input', function() {
        validateSearchFormDesktop();
    });

    // Listen for city autocomplete selection (stationSelected event from city-autocomplete.js)
    $(document).on('stationSelected', function() {
        validateSearchFormDesktop();
    });

    // ============================================================
    // Nutzfahrzeuge Search Form Validation
    // ============================================================
    function validateNutzfahrzeugeFormDesktop() {
        // 1. Check location (Anmietort)
        var anmietort = $('#nutz-anmietort-desktop').val();
        var hasLocation = anmietort && anmietort.trim().length > 0;

        // 2. Check date (must be today or in the future)
        var anmietdatum = $('#nutz-anmietdatum').val();
        var hasValidDate = false;

        if (anmietdatum) {
            // Format can be "DD.MM.YYYY" or "Di, DD.MM.YYYY" (with weekday prefix)
            var dateMatch = anmietdatum.match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/);
            if (dateMatch) {
                var day = parseInt(dateMatch[1]);
                var month = parseInt(dateMatch[2]) - 1;
                var year = parseInt(dateMatch[3]);
                var inputDate = new Date(year, month, day);
                var today = new Date();
                today.setHours(0, 0, 0, 0);
                hasValidDate = (inputDate >= today);
            }
        }

        // 3. Check category selection (either tile or dropdown)
        var hasCategory = false;
        // Check if any category tile is active
        if ($('.nutz-category-tile.active').length > 0) {
            hasCategory = true;
        }
        // Or check if dropdown has a value
        var dropdownVal = $('#nutz-all-categories-desktop').val();
        if (dropdownVal && dropdownVal.trim().length > 0) {
            hasCategory = true;
        }
        // Or check hidden field
        var hiddenCategoryId = $('#nutz-selected-category-id-desktop').val();
        if (hiddenCategoryId && hiddenCategoryId.trim().length > 0) {
            hasCategory = true;
        }

        // 4. Check if opening hours warning is active
        var hasOpeningHoursWarning = window.OpeningHoursValidation && window.OpeningHoursValidation.warningActive;

        // 5. Enable/disable button
        var button = $('#nutz-search-desktop');

        if (hasLocation && hasValidDate && hasCategory && !hasOpeningHoursWarning) {
            button.prop('disabled', false).attr('title', '');
        } else {
            var msg = [];
            if (!hasLocation) msg.push('Abholort');
            if (!hasValidDate) msg.push('gültiges Abholdatum');
            if (!hasCategory) msg.push('Kategorie');
            if (hasOpeningHoursWarning) msg.push('anderes Datum (Vermieter geschlossen)');
            button.prop('disabled', true).attr('title', 'Bitte ' + msg.join(', ') + ' auswählen');
        }
    }
    // Expose for opening-hours-validation.js re-trigger
    window.validateNutzfahrzeugeFormDesktop = validateNutzfahrzeugeFormDesktop;

    // Initial validation on page load for Nutzfahrzeuge form
    setTimeout(function() {
        validateNutzfahrzeugeFormDesktop();
    }, 150);

    // Event listeners for Nutzfahrzeuge validation (using event delegation for dynamic elements)
    $(document).on('change input', '#nutz-anmietort-desktop, #nutz-anmietdatum, #nutz-all-categories-desktop, #nutz-selected-category-id-desktop', function() {
        validateNutzfahrzeugeFormDesktop();
    });

    // Listen for category tile clicks
    $(document).on('click', '.nutz-category-tile', function() {
        setTimeout(function() {
            validateNutzfahrzeugeFormDesktop();
        }, 50);
    });

    // Listen for city autocomplete selection in Nutzfahrzeuge form
    $(document).on('stationSelected', function() {
        validateNutzfahrzeugeFormDesktop();
    });

    // Also trigger validation when Nutzfahrzeuge tab is activated
    $(document).on('shown.bs.tab', 'a[href="#tab-nutzfahrzeuge"]', function() {
        setTimeout(function() {
            validateNutzfahrzeugeFormDesktop();
        }, 100);
    });

    function showSearchSubmitAnimation($form) {
        var formId = $form.attr('id');
        if (!$('body#home').length || (formId !== 'searchForm' && formId !== 'nutzfahrzeugeSearchForm' && formId !== 'nutzfahrzeugeSearchFormDesktop')) {
            return;
        }

        var $animation = $form.find('.search-submit-animation');
        if (!$animation.length) {
            $animation = $(
                '<div class="search-submit-animation" role="status" aria-live="polite" aria-hidden="true">' +
                    '<div class="search-submit-animation__track">' +
                        '<svg class="search-submit-truck" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                            '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>' +
                            '<path d="M15 18H9"></path>' +
                            '<path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>' +
                            '<circle cx="17" cy="18" r="2"></circle>' +
                            '<circle cx="7" cy="18" r="2"></circle>' +
                        '</svg>' +
                    '</div>' +
                    '<span class="search-submit-animation__label">Gleich geht es weiter...</span>' +
                '</div>'
            );
            $form.append($animation);
        }

        $form.addClass('is-search-submitting');
        $animation.attr('aria-hidden', 'false');
    }

    $('body#home').on('submit', '#searchForm, #nutzfahrzeugeSearchForm, #nutzfahrzeugeSearchFormDesktop', function(e) {
        var form = this;
        var $form = $(form);
        if ($form.data('submitAnimationDone')) {
            return true;
        }

        e.preventDefault();
        $form.data('submitAnimationDone', true);
        showSearchSubmitAnimation($form);

        window.setTimeout(function() {
            form.submit();
        }, 3000);
    });

    $("#searchBtn").click(function () {
        if (!$(this).prop('disabled')) {
            $("#searchForm").submit();
        }
    });

    $("#customer-login-button").click(function () {
        $("#user-login").submit();
    });

    $("#customer-login-button-t").click(function () {
        $("#user-login-t").submit();
    });

    $("#anbieter-login-button").click(function () {
        $(this).closest("form").submit();
    });

    $("#anbieter-login-button-t").click(function () {
        $(this).closest("form").submit();
    });

    $("#guest-login-button").click(function () {
        $("#guest-login").submit();
    });

    $("#guest-login-button-t").click(function () {
        $("#guest-login-t").submit();
    });
    /*
        $("#searchForm").keypress(function (e) {
            if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
                if (!$("#anmietort").val()) {
                    $("#anmietort").parent('div').addClass('has-error');
                    $('<style>#change-data .form-group .anmietort:before, .frontpage-header .anmietort:before {content:"\\f071";color:#e10000}</style>').appendTo('head');
                }
                else {
                    $("#searchForm").submit();
                }
            } else {
                return true;
            }
        });
    */
    $("#submit_form,.submit_form_id").click(function (e) {
        e.preventDefault();
        var $form = $(this).closest('form');

        // Ensure all service checkboxes are properly synchronized
        $('.features input[type="checkbox"][data-service-id]').each(function() {
            var serviceId = $(this).data('service-id');
            var isChecked = $(this).is(':checked');
            var $hidden = $('#service-status-hidden-' + serviceId);
            if ($hidden.length > 0) {
                $hidden.val(isChecked ? '1' : '0');
            }
        });

        // Debug logging (can be removed in production)
        if (window.console && console.log) {
            var serviceData = [];
            $('input[name^="services"]').each(function() {
                serviceData.push({
                    name: $(this).attr('name'),
                    value: $(this).val(),
                    type: $(this).attr('type'),
                    checked: $(this).is(':checked')
                });
            });
        }

        // Submit the form
        $form.submit();
    });

    $("#country").select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        dropdownCssClass: ':all:',
    });

    $("#pay-method").select2({
        minimumResultsForSearch: Infinity,
        width: '320px',
        dropdownCssClass: ':all:',
        placeholder: function () {
            $(this).data('placeholder');
        }
    });

    $("#card-expire-month").select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        dropdownCssClass: ':all:',
        placeholder: function () {
            $(this).data('placeholder');
        }
    });

    $("#card-expire-year").select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        dropdownCssClass: ':all:',
        placeholder: function () {
            $(this).data('placeholder');
        }
    });

    $("#a1").select2({
        minimumResultsForSearch: Infinity,
        width: '374px',
        dropdownCssClass: ':all:',
    });
    $("#a2").select2({
        minimumResultsForSearch: Infinity,
        width: '374px',
        dropdownCssClass: ':all:',
    });
    $("#a3").select2({
        minimumResultsForSearch: Infinity,
        width: '374px',
        dropdownCssClass: ':all:',
    });
    $("#a4").select2({
        minimumResultsForSearch: Infinity,
        width: '374px',
        dropdownCssClass: ':all:',
    });


    $("[data-type='services']").select2({
        minimumResultsForSearch: Infinity,
        width: '52px',
        dropdownCssClass: ':all:',
    });

    $('.fa-question-circle').each(function () {
        if ($(this).data('displaychange') != "0") {
            $(this).parent().css({
                'display': 'inline-block'
            });
        }

        var data = $(this).attr('data-title');
        // Only add tooltip if data-title attribute exists
        if (data) {
            // Allow <br> tags, strip all other HTML
            var safeHtml = data.replace(/<(?!br\s*\/?)[^>]*>/gi, '');
            var $bubble = $('<span class="tt-bubble top"></span>');
            $bubble.html(safeHtml);
            $(this).append($bubble);
        }
    });

    $('.fa-question-circle').parent().each(function () {
        if ($(this).hasClass('panel-title')) {
            $(this).addClass('tt big');
        } else if ($(this).hasClass('code-box')) {
            $(this).addClass('tt misc');
        } else {
            $(this).addClass('tt');
        }
    });
    /*
    $(window).scroll(function () {
        $('.tt').each(function () {
            var distance1 = $(this).offset().top - 75;

            if ($(window).scrollTop() >= distance1) {
                $(this).find('.tt-bubble').removeClass('top').addClass('bottom');
            } else {
                $(this).find('.tt-bubble').removeClass('bottom').addClass('top');
            }
        });

        $('.tip').parent().each(function () {
            var distance2 = $(this).offset().top - 75;

            if ($(window).scrollTop() >= distance2) {
                $(this).find('.tip').addClass('bottom');
            } else {
                $(this).find('.tip').removeClass('bottom');
            }
        });
    });
    */
    if (typeof resultview === 'undefined') {
        $(window).scroll(function () {
            $('.tt').each(function () {
                var distance1 = $(this).offset().top - 75;

                /*
                if ($(this).find('.tt-bubble').height() >= distance1) {
                    var h1 = $(this).find('.tt-bubble').height() * 1 + 30;
                    var height1 = '-' + h1 + 'px';
                    $(this).find('.tt-bubble').removeClass('top').addClass('bottom').css('bottom', height1);
                } else {*/
                if ($(window).scrollTop() >= distance1 && distance1 > 0) {
                    $(this).find('.tt-bubble').removeClass('top').addClass('bottom');
                } else {
                    $(this).find('.tt-bubble').removeClass('bottom').addClass('top');
                }
                // }
            });
            $('.tip').parent().each(function () {
                var distance2 = $(this).offset().top - 75;

                if ($(this).find('.tip').height() >= distance2) {
                    var h2 = $(this).find('.tip').height() * 1 + 30;
                    var height2 = '-' + h2 + 'px';
                    $(this).find('.tip').addClass('bottom').css('bottom', height2);
                } else {
                    if ($(window).scrollTop() >= distance2) {
                        $(this).find('.tip').addClass('bottom');
                    } else {
                        $(this).find('.tip').removeClass('bottom');
                    }
                }
            });
        });
    }
    $(window).trigger('scroll');

    $('.tt').hover(function () {
        $(this).children().find('.tt-bubble').css('visibility', 'visible');
    }, function () {
        $(this).children().find('.tt-bubble').css('visibility', 'hidden');
    });

    $('.features .help-block').click(function () {
        if ($(this).parent().find('input:checkbox').is(':checked')) {
            $(this).parent().removeClass('checked').find('input:checkbox').prop('checked', false);
            $(this).parent().parent().find('.select-box select').prop('disabled', true);
        } else {
            $(this).parent().addClass('checked').find('input:checkbox').prop('checked', true);
            $(this).parent().parent().find('.select-box select').prop('disabled', false);
        }
    });

    $('.close-button').click(function () {
        $(this).parent().hide();
    });

    var selectedFilter = [];


    //extras

    $('[data-action="calculate"]').click(function () {
        calculateFinalPrice();
    });


    $('#vollkaskoDiebstahl').click(function () {
        if ($(this).is(':checked') == false) {
            $('input[data-type="vollkaskoDiebstahl_sb"]').prop("checked", false);
            $('input[data-type="vollkaskoDiebstahl_sb"]').parent().removeClass('checked');
            calculateFinalPrice();
        }
    });

    $('input[data-type="vollkaskoDiebstahl_sb"]').click(function () {
        $('#vollkaskoDiebstahl').prop("checked", true);
    });

    $('div[data-radio="paymentMethode"]').click(function () {
        $('div[data-radio="paymentMethode"]').removeClass('checked');
        $(this).find("input").prop("checked", true);
        $(this).addClass("checked");
        calculateFinalPrice();

        if ($(this).data('offerid')) {
            var offerid = parseInt($('.baseprice').data('startofferid'));
            if (offerid != parseInt($(this).data('offerid'))) {
                $('#overlay_loading').show();
                var form = $('<form action="" method="post">' +
                    '<input type="hidden" name="offerid" value="' + $(this).data('offerid') + '" />' +
                    '</form>');
                $('body').append(form);
                $(form).submit();
            }
        }
    });

    $('div[data-radio="kmRate"]').click(function () {
        $('div[data-radio="kmRate"]').removeClass('checked');
        $(this).find("input").prop("checked", true);
        $(this).addClass("checked");
        calculateFinalPrice();

        if ($(this).data('offerid')) {
            var offerid = parseInt($('.baseprice').data('startofferid'));
            if (offerid != parseInt($(this).data('offerid'))) {

                var form = $('<form action="" method="post">' +
                    '<input type="hidden" name="offerid" value="' + $(this).data('offerid') + '" />' +
                    '</form>');
                $('body').append(form);
                $(form).submit();
            }
        }
    });

    // Recalculate price when service checkbox is toggled
    $(document).on('change', '.features .checkbox input[type="checkbox"]', function() {
        calculateFinalPrice();
    });

    // Recalculate price when service quantity changes
    $(document).on('change', '.features select[name*="[amount]"]', function() {
        calculateFinalPrice();
    });

    // Update hidden status fields when checkboxes change (data integrity)
    $(document).on('change', '.features input[type="checkbox"][data-service-id]', function() {
        var serviceId = $(this).data('service-id');
        var isChecked = $(this).is(':checked');
        // Update hidden field (if it exists)
        var $hidden = $('#service-status-hidden-' + serviceId);
        if ($hidden.length > 0) {
            $hidden.val(isChecked ? '1' : '0');
        }
    });

    if ($('#change-data').length > 0 && $.cookie('customergroup')) {
        $.each(JSON.parse($.cookie('customergroup')), function (index, value) {
            $('#change-data #' + value).prop('checked', true);
            $('#change-data #' + value).parent().addClass('checked');
        });
    }


    $('input[data-disabled="1"]').click(function (event) {
        event.preventDefault();
    });


    $('.scrollToPosition').click(function () {
        var that = $(this);
        setTimeout(function () {
            var panelResult = that.closest('.panel-result');
            $('html, body').animate({
                scrollTop: panelResult.offset().top - 15
            }, 500);
        }, 310);
    });
});

function filterResults(scrollstop) {
    scrollstop = scrollstop || 0;
    selectedFilter = [];
    $('#filtering input:checked').each(function () {
        selectedFilter.push($(this).attr('id'));
    });

    $.cookie('selectedFilter', JSON.stringify(selectedFilter), {path: "/"});

    //Hide everything
    var selection = $('div.panel-result');
    selection.hide();
    //Filter by customer groups
    var customergroup = [];
    if ($('#customer-privat').is(':checked') && $('#customer-student').is(':checked') && $('#customer-company').is(':checked')) {
        customergroup.push("privat");
        customergroup.push("student");
        customergroup.push("company");
        selection = selection;
    }
    else if ($('#customer-privat').is(':checked') && $('#customer-student').is(':checked')) {
        customergroup.push("privat");
        customergroup.push("student");
        selection = selection.filter('[data-customergroup="privat"],[data-customergroup="student"]');
    }
    else if ($('#customer-privat').is(':checked') && $('#customer-company').is(':checked')) {
        customergroup.push("privat");
        customergroup.push("company");
        selection = selection.filter('[data-customergroup="privat"],[data-customergroup="company"]');
    }
    else if ($('#customer-student').is(':checked') && $('#customer-company').is(':checked')) {
        customergroup.push("company");
        customergroup.push("student");
        selection = selection.filter('[data-customergroup="student"],[data-customergroup="company"]');
    }
    else if ($('#customer-privat').is(':checked')) {
        customergroup.push("privat");
        selection = selection.filter('[data-customergroup="privat"]');
    }
    else if ($('#customer-student').is(':checked')) {
        customergroup.push("student");
        selection = selection.filter('[data-customergroup="student"]');
    }
    else if ($('#customer-company').is(':checked')) {
        customergroup.push("company");
        selection = selection.filter('[data-customergroup="company"]');
    }
    else {
        customergroup.push("privat");
        customergroup.push("student");
        customergroup.push("company");
    }
    $.cookie('customergroup', JSON.stringify(customergroup), {expires: 7, path: '/'});

    //$('#fav-sofort').parent().find('span').data("filterprice", "99999");
    $('#filtering .checkbox').hide();
    $('#filter-3 .checkbox').show();
    $('#filter-3 .checkbox').parent().hide();

    $('#filtering .checkbox').find('span').data("filterprice", "99999");
    $.each(allResults, function (index, value) {
        if (jQuery.inArray(value.customergroup, customergroup) >= 0) {
            refreshFilters(value);
        }
        else {
            if (value.customergroup) {
                var element = $('#customer-' + value.customergroup);
                element.parent().show();
                if (parseFloat(element.parent().find('span').data("filterprice")) > parseFloat(value.price) || element.parent().find('span').data("filterprice") == undefined) {
                    element.parent().find('span').data("filterprice", value.price);
                    element.parent().find('span').html("ab " + value.priceFormat + " €");
                }

                var element = $('#customer-' + value.customergroup + '-t');
                element.parent().show();
                if (parseFloat(element.parent().find('span').data("filterprice")) > parseFloat(value.price) || element.parent().find('span').data("filterprice") == undefined) {
                    element.parent().find('span').data("filterprice", value.price);
                    element.parent().find('span').html("ab " + value.priceFormat + " €");
                }
            }
        }
    });

    //Filter by driving license class

    var fsclasses = [];
    if ($('#fs-B').is(':checked')) {
        fsclasses.push("B");
        fsclasses.push("L")
    }
    ;
    if ($('#fs-C').is(':checked')) {
        fsclasses.push("C");
        fsclasses.push("B");
        fsclasses.push("C1");
        fsclasses.push("L")
    }
    ;
    if ($('#fs-C1').is(':checked')) {
        fsclasses.push("C1");
        fsclasses.push("B");
        fsclasses.push("L")
    }
    ;
    if ($('#fs-D').is(':checked')) {
        fsclasses.push("D");
        fsclasses.push("D1");
        fsclasses.push("B");
        fsclasses.push("L")
    }
    ;
    if ($('#fs-D1').is(':checked')) {
        fsclasses.push("D1");
        fsclasses.push("B");
        fsclasses.push("L")
    }
    ;
    if ($('#fs-L').is(':checked')) {
        fsclasses.push("L")
    }
    ;
    if ($('#fs-T').is(':checked')) {
        fsclasses.push("T");
        fsclasses.push("L")
    }
    ;
    if ($('#fs-BE').is(':checked')) {
        fsclasses.push("BE");
        fsclasses.push("B");
        fsclasses.push("L")
    }
    ;
    if ($('#fs-B96').is(':checked')) {
        fsclasses.push("B96");
        fsclasses.push("B");
        fsclasses.push("L")
    }
    ;
    if ($('#fs-C1E').is(':checked')) {
        fsclasses.push("C1E");
        fsclasses.push("BE");
        fsclasses.push("B");
        fsclasses.push("L")
    }
    ;
    if ($('#fs-CE').is(':checked')) {
        fsclasses.push("CE");
        fsclasses.push("C");
        fsclasses.push("C1");
        fsclasses.push("C1E");
        fsclasses.push("B");
        fsclasses.push("BE");
        fsclasses.push("T");
        fsclasses.push("L")
    }
    ;
    if (fsclasses.length > 0) {
        selection = selection.filter(function () {
            var res = false;

            if (jQuery.inArray($(this).data("fsclass"), fsclasses) >= 0)
                return res = true;

            return res;
        });
    }


    //Filter by beliebte Filter
    if ($('#fav-ohne-sb').is(':checked')) {
        selection = selection.filter('[data-withoutsb="1"]');
    }
    if ($('#fav-sofort').is(':checked')) {
        selection = selection.filter('[data-directbooking="1"]');
    }
    if ($('#fav-km-frei').is(':checked')) {
        selection = selection.filter('[data-unlimitedKm="1"]');
    }
    if ($('#fav-fahrer').is(':checked')) {
        selection = selection.filter('[data-addDriverFree="1"]');
    }
    if ($('#fav-reifen').is(':checked')) {
        selection = selection.filter('[data-snowTiresFree="1"]');
    }

    //vehmodel
    pattern = [];
    $.each($('[data-filtertype="vehmodel"]'), function (index, value) {
        if ($(this).is(':checked') == true) {
            pattern.push('[data-vehmodel="' + $(this).val() + '"]');
        }
    });
    if (pattern.length > 0)
        selection = selection.filter(pattern.join());

    //vehtype
    pattern = [];
    $.each($('[data-filtertype="vehtype"]'), function (index, value) {
        if ($(this).is(':checked') == true) {
            pattern.push('[data-vehtype="' + $(this).val() + '"]');
        }
    });
    if (pattern.length > 0)
        selection = selection.filter(pattern.join());


    //Filter by versicherungen
    if ($('#versicherung-glas').is(':checked')) {
        selection = selection.filter('[data-windowDamage="1"]');
    }
    if ($('#versicherung-dach').is(':checked')) {
        selection = selection.filter('[data-roofDamage="1"]');
    }
    if ($('#versicherung-reifen').is(':checked')) {
        selection = selection.filter('[data-tireDamage="1"]');
    }
    if ($('#versicherung-unterboden').is(':checked')) {
        selection = selection.filter('[data-unterbodyDamage="1"]');
    }
    if ($('#versicherung-ohne-sb').is(':checked')) {
        selection = selection.filter('[data-withoutSb="1"]');
    }

    //Filter by inklusive extras
    if ($('#extras-kmfrei').is(':checked')) {
        selection = selection.filter('[data-unlimitedkm="1"]');
    }
    if ($('#extras-aircondition').is(':checked')) {
        selection = selection.filter('[data-aircondition="1"]');
    }
    if ($('#extras-zusatzfahrer').is(':checked')) {
        selection = selection.filter('[data-adddriverfree="1"]');
    }
    if ($('#extras-towbar').is(':checked')) {
        selection = selection.filter('[data-towbarstatus="1"]');
    }
    if ($('#extras-hydraulicramp').is(':checked')) {
        selection = selection.filter('[data-hydraulicrampstatus="1"]');
    }
    if ($('#extras-navigationsystem').is(':checked')) {
        selection = selection.filter('[data-navigationsystem="1"]');
    }
    if ($('#extras-snowtires').is(':checked')) {
        selection = selection.filter('[data-snowtiresfree="1"]');
    }

    //Filter by display name
    pattern = [];
    $.each($('[data-filtertype="provider"]'), function (index, value) {
        if ($(this).is(':checked') == true) {
            pattern.push('[data-provider="' + $(this).val() + '"]');
        }
    });
    if (pattern.length > 0)
        selection = selection.filter(pattern.join());

    //filter by anmietstaion
    patternVis = [];
    if ($('#station-train_station').is(':checked')) {
        patternVis.push('train_station');
    }

    if ($('#station-city').is(':checked')) {
        patternVis.push('city');
    }

    if ($('#station-airport').is(':checked')) {
        patternVis.push('airport');
    }

    if ($('#station-ferry').is(':checked')) {
        patternVis.push('ferry');
    }

    $('.startStation').each(function () {
        var select = $(this);
        $(this).html('');
        $(this).parent().find('.startStation-org option').each(function () {
            if ($.inArray($(this).data('stationtype'), patternVis) > -1) {
                var newState = new Option($(this).text(), $(this).val(), false, true);
                newState.setAttribute("data-long", $(this).data('long'));
                newState.setAttribute("data-lati", $(this).data('lati'));
                newState.setAttribute("data-stationtype", $(this).data('stationtype'));
                select.append(newState).trigger('change');
            }
        });
        if ($(this).find('option').length == 0) {
            if ($(this).parents(".panel-result").data("offerid") > 0) {
                var exclude = $(this).parents(".panel-result").data("offerid");
                selection = selection.filter(function (index) {
                    return $(this).data("offerid") != exclude;
                });
            }
        }
    });


    $('.count_offers').text(selection.length);
    if (selection.length == 0)
        $('#no-results').show();
    else
        $('#no-results').hide();
    selection.show();
    refreshPositioning();
    if (scrollstop != 1)
        window.scrollTo(0, 0);
}

function comment(element) {
    element.wrap(function () {
        return '<!--' + this.outerHTML + '"-->';
    });
}

function uncomment(element) {
    element.wrap(function () {
        return '<!--' + this.outerHTML + '"-->';
    });
}

function calculateFinalPrice() {

    var baseprice = parseFloat($('.baseprice').data('baseprice'));
    var extrasCost = 0;
    var extrasBreakdown = [];

    // Get rental duration
    var rentalDays = getRentalDays();

    // Calculate insurance/coverage add-ons, payment method, and other options
    $('[data-addPrice]').each(function () {
        if ($(this).is(':checked')) {
            var addPrice = parseFloat($(this).data("addprice")) || 0;
            baseprice = baseprice + addPrice;

            // Add to breakdown if it has a cost (payment method, insurance options, etc.)
            if (addPrice !== 0) {
                var optionLabel = '';
                var inputName = $(this).attr('name') || '';

                // Try to get label from different possible structures
                var $extrasOption = $(this).closest('.extras-option');
                var $label = $(this).closest('label');

                if ($extrasOption.length > 0) {
                    optionLabel = $extrasOption.find('.extras-option-info strong').first().text();
                } else if ($label.length > 0) {
                    optionLabel = $label.find('strong').first().text() || $label.text();
                }

                // Fallback labels based on input name
                if (!optionLabel || optionLabel.trim() === '') {
                    if (inputName === 'paymentMethode') {
                        optionLabel = 'Zahlungsart';
                    } else if (inputName.indexOf('coverage') !== -1 && inputName.indexOf('vollkasko') !== -1) {
                        optionLabel = 'Vollkasko-Versicherung';
                    } else if (inputName.indexOf('coverage') !== -1 && inputName.indexOf('diebstahl') !== -1) {
                        optionLabel = 'Diebstahlschutz';
                    } else {
                        optionLabel = 'Option';
                    }
                }

                extrasBreakdown.push({
                    text: optionLabel.trim(),
                    cost: addPrice
                });
            }
        }
    });

    // Calculate services/extras (NEW LOGIC)
    $('.features .checkbox').each(function() {
        var $checkbox = $(this).find('input[type="checkbox"]:not([type="hidden"])');
        var $quantitySelect = $(this).find('select[name*="[amount]"]');

        if ($checkbox.length > 0 && $checkbox.is(':checked')) {
            var serviceId = $(this).data('service-id');
            var serviceName = $(this).data('service-name') || 'Service';
            var quantity = parseInt($quantitySelect.val()) || 1;

            // Get pricing data from data attributes
            var freeStatus = parseInt($(this).data('free-status')) || 0;
            var freeAmount = parseInt($(this).data('free-amount')) || 0;
            var pricePerDay = parseFloat($(this).data('price-per-day')) || 0;
            var pricePerWeek = parseFloat($(this).data('price-per-week')) || 0;
            var pricePerMonth = parseFloat($(this).data('price-per-month')) || 0;
            var pricePerRental = parseFloat($(this).data('price-per-rental')) || 0;
            var priceMaximum = parseFloat($(this).data('price-maximum')) || 0;

            // Calculate billable quantity (subtract free units)
            var billableQuantity = quantity;
            if (freeStatus > 0 && freeAmount > 0) {
                billableQuantity = Math.max(0, quantity - freeAmount);
            }

            // Calculate service cost
            var serviceCost = 0;
            if (billableQuantity > 0) {
                serviceCost = calculateServicePrice(
                    billableQuantity,
                    rentalDays,
                    pricePerDay,
                    pricePerWeek,
                    pricePerMonth,
                    pricePerRental,
                    priceMaximum
                );
            }

            extrasCost += serviceCost;

            // Add to breakdown for display
            if (quantity > 0) {
                var breakdownText = quantity + 'x ' + serviceName;
                if (freeStatus > 0 && freeAmount > 0 && quantity <= freeAmount) {
                    breakdownText += ' (kostenlos)';
                } else if (freeStatus > 0 && freeAmount > 0) {
                    breakdownText += ' (' + freeAmount + ' kostenlos)';
                }
                extrasBreakdown.push({
                    text: breakdownText,
                    cost: serviceCost
                });
            }
        }
    });

    // Update breakdown display
    updateExtrasBreakdown(extrasBreakdown);

    // Update total price
    var totalPrice = baseprice + extrasCost;
    $('#final_price').text(totalPrice.format(2, 3, '.', ','));
}

function calculateServicePrice(quantity, days, pricePerDay, pricePerWeek, pricePerMonth, pricePerRental, priceMaximum) {
    var cost = 0;

    // Priority order: per rental > per month > per week > per day
    if (pricePerRental > 0) {
        cost = pricePerRental * quantity;
    } else if (pricePerMonth > 0 && days >= 30) {
        var months = Math.ceil(days / 30);
        cost = pricePerMonth * quantity * months;
    } else if (pricePerWeek > 0 && days >= 7) {
        var weeks = Math.ceil(days / 7);
        cost = pricePerWeek * quantity * weeks;
    } else if (pricePerDay > 0) {
        cost = pricePerDay * quantity * days;
    }

    // Apply maximum cap if set
    if (priceMaximum > 0 && cost > priceMaximum * quantity) {
        cost = priceMaximum * quantity;
    }

    return cost;
}

function getRentalDays() {
    // Try to get from data attribute first
    var daysFromAttr = $('.grey-box').first().data('rental-days');
    if (daysFromAttr && daysFromAttr > 0) {
        return parseInt(daysFromAttr);
    }

    // Fallback: Parse rental duration from the page title
    var titleText = $('.grey-box .title').first().text();
    var daysMatch = titleText.match(/(\d+)\s+Tag/);
    if (daysMatch && daysMatch[1]) {
        return parseInt(daysMatch[1]);
    }
    return 1; // Default to 1 day if not found
}

function updateExtrasBreakdown(extrasBreakdown) {
    var $breakdown = $('#extras-breakdown');
    if ($breakdown.length === 0) {
        return; // Skip if breakdown element doesn't exist
    }

    $breakdown.empty();

    if (extrasBreakdown.length > 0) {
        extrasBreakdown.forEach(function(item) {
            var costText = item.cost !== 0
                ? (item.cost >= 0 ? '+' : '') + item.cost.toFixed(2).replace('.', ',') + ' €'
                : 'kostenlos';

            $breakdown.append(
                '<div class="sidebar-price-row">' +
                '<span>' + item.text + ':</span>' +
                '<span>' + costText + '</span>' +
                '</div>'
            );
        });
    }
}

function validateName(string) {
    var regex = /^[\p{L}\p{M} .'\u2019-]+$/u;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function validateStreet(string) {
    var regex = /^[\p{L}\p{M}\p{N} .,'\u2019()&\/-]+$/u;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function validateStreetNo(string) {
    var regex = /^[0-9]+[a-zA-Z]?(?:[\/-][0-9]+[a-zA-Z]?)?$/;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function validateZip(string) {
    var regex = /^[\p{L}\p{N}][\p{L}\p{N} -]{2,9}$/u;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function phoneCountry(string) {
    var regex = /^[0-9]{1,3}$/;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function phoneNumber(string) {
    var regex = /^[0-9-]{1,14}$/;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function validateCardnumberAmex(string) {
    var regex = /^[0-9-]{15}$/;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function validateCardnumberDiners(string) {
    var regex = /^[0-9-]{14}$/;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function validateCardnumberMaster(string) {
    var regex = /^[0-9-]{16}$/;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function validateCardnumberVisa(string) {
    var regex = /^[0-9-]{13,16}$/;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function validateCvc(string) {
    var regex = /^[0-9-]{3}$/;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function validateCvc4(string) {
    var regex = /^[0-9-]{4}$/;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function validateEmail(string) {
    var regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    if (string.length > 0 && regex.test(string)) {
        return true;
    }
    else {
        return false;
    }
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function hasError(id) {
    $("#" + id).parent('div').addClass('has-error');
    $('<style>.frontpage-header .' + id + ':before {content:"\\f071";color:#e10000}</style>').appendTo('head');
}

jQuery(window).resize(function () {
    newHeight();
    ZoomFix();
    SaleTabs();
    jQuery('.frontpage-header:not(.frontpage-header-redesign), .sidebar').css({
        "height": ""
    });
    if (document.documentElement.clientWidth > 992) {
        sameHeight();
    }
    jQuery('.frontpage-header, .sales .specials, section.content.transport').css('background-size', '100% auto');
});

Number.prototype.format = function (n, x, s, c) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

//google maps route
function googleMapsRoute() {

    $('#submit_adress').click(function () {
        var address = $('#address').val();
        if (address != '') {
            $('#map-directions').show();
            $('#map-directions2').hide();
            var directionsService = new google.maps.DirectionsService();
            var directionsDisplay = new google.maps.DirectionsRenderer();

            var map = new google.maps.Map(document.getElementById('map-directions'), {
                zoom: 6,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            directionsDisplay.setMap(map);

            var address = $('#address').val();
            var address_destination = $('#address_destination').val();
            var request = {
                origin: address,
                destination: address_destination,
                travelMode: google.maps.DirectionsTravelMode.DRIVING
            };

            directionsService.route(request, function (response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(response);
                }
            });

            $('#map-directions-link').prop("href", "https://www.google.com/maps/dir/" + address + "/" + address_destination + "/")
        }
    });
}


/* Gregor */
$(document).ready(function () {
    // Handle checkout button: show loading overlay and submit form with offerid
    $(document).on("click", "[data-action=\"checkout\"]", function(e){
        try { $("#overlay_loading").show(); } catch(err) {}
        var $btn = $(this);
        var $panel = $btn.closest(".panel-result");
        var offerid = $panel.data("offerid");
        var $form = $btn.closest("form");
        if ($form.length === 0) { $form = $panel.find("form").first(); }
        if ($form.length === 0) { $form = $("<form method=\"post\" action=\"/extras.html\"></form>").appendTo($panel); }
        var $hid = $form.find("input[name='offerid']");
        var selectedOfferid = ($hid.length && $hid.val()) ? $hid.val() : offerid;
        if (selectedOfferid) { offerid = selectedOfferid; }
        if ($hid.length) { $hid.val(offerid); } else { $("<input />").attr({ type: "hidden", name: "offerid", value: offerid }).appendTo($form); }
        // vollkaskoOptional: Variante (haftpflicht|vollkasko) durchreichen
        var coverageVariant = $panel.data("coveragevariant");
        if (coverageVariant) {
            var $cv = $form.find("input[name='coverageVariant']");
            if ($cv.length) { $cv.val(coverageVariant); } else { $("<input />").attr({ type: "hidden", name: "coverageVariant", value: coverageVariant }).appendTo($form); }
        }
        $form.trigger("submit");
    });


    //  $("#without_login").trigger("click");
})

$(".rek-del-img").click(function () {
    var id = $(this).data('idx');
    $("#rek-del-img").val(id);
    $("#rek-form").submit();
});

$("#rek-upload-btn").click(function () {
    $("#rek_file_table").append('<tr><td><input type="file" name="beleg[]"></td></tr>');
});

// Birthday field - manual input enabled, datepicker disabled
/*
$('#geburtsdatum_readonly').datepicker({
    dateFormat: "dd.mm.yy",
    changeMonth: true,
    changeYear: true,
    defaultDate: "-25y",
    yearRange: (new Date().getFullYear() - 80) + ":" + (new Date().getFullYear() - 17),
    numberOfMonths: 1,
});
*/

$("#btn-register-now").on("click", function (e) {
    e.preventDefault();
    $("#my-res-loginform").hide();
    $("#my-res-register-form").show();
    $("#my-res-advantages").hide();
    $('#my-res-register-form input[name="active_registration"]').val(1);
});

$("#with_login").click(function () {
    $("#show-reservations-btn, #without_login_container").hide()
    $("#res-login-btn, #with_login_container").show();
    // change url
    $("#my-res-loginform").attr("action", '/kundenservice/user/login.html');
})
$("#without_login").click(function () {
    $("#res-login-btn, #with_login_container").hide();
    $("#show-reservations-btn, #without_login_container").show()
    $("#my-res-loginform").attr("action", '/kundenservice/guest/login.html');
})

$("#rek-reason").select2({
    width: '100%',
    minimumResultsForSearch: Infinity,
    dropdownCssClass: ':all:',
});

$("#rek-res-autovermietung").select2({
    width: '100%',
    minimumResultsForSearch: Infinity,
    dropdownCssClass: ':all:',
});

$("#fahrzeugmodell").select2({
    width: '100%',
    minimumResultsForSearch: Infinity,
    dropdownCssClass: ':all:',
});

$('.formular_fahrzeugklasse').click(function () {
        var veh_class = $(this).val();
        if (veh_class == "Kuehlfahrzeug")
            veh_class = 'Kühlfahrzeug';

        $("#fahrzeugmodell").select2('destroy');
        $("#fahrzeugmodell").find('option').attr('disabled', 'true');
        $("#fahrzeugmodell").find('option:first').removeAttr('disabled');
        $("#fahrzeugmodell").find('option:first').attr('checked', 'checked');
        $("#fahrzeugmodell").find('option[data-vehicleclass="' + veh_class + '"]').removeAttr('disabled');

        $("#fahrzeugmodell").select2({
            width: '100%',
            minimumResultsForSearch: Infinity,
            dropdownCssClass: ':all:',
        });
    $('#select2-fahrzeugmodell-container').html('Alle Fahzeugmodelle');
    }
);

function setRatingData(rId) {
    var dialog = $('#detailsRatingDialog');
    var data = window['rating_' + rId];

    function getStars(num_stars) {
        var star = '<i class="fa fa-star"></i>';
        var num = Math.floor(num_stars);
        var out = "";
        for (i = 0; i < num; i++) {
            out += star;
        }
        return out;
    }

    // set data to modal container
    dialog.find('.title').text('Gesamtbewertung von ' + data.name);
    dialog.find('.rating-title').text('Bewertung Vermieter ' + data.provider);
    dialog.find('.provider-rating-condition').html(getStars(data.rating_provider_condition));
    dialog.find('.provider-rating-speed').html(getStars(data.rating_provider_speed));
    dialog.find('.provider-rating-service').html(getStars(data.rating_provider_service));
    if (data.rating_provider_comment == "") {
        dialog.find('.provider-comment-wrapper').hide();
    }
    else {
        dialog.find('.provider-comment-wrapper').show();
        dialog.find('.provider-comment').text(data.rating_provider_comment);
    }
    dialog.find('.rating-lkw-recommend').html(getStars(data.rating_lkw_recommend));
    if (data.rating_lkw_comment == "") {
        dialog.find('.lkw-comment-wrapper').hide();
    }
    else {
        dialog.find('.lkw-comment-wrapper').show();
        dialog.find('.lkw-comment').text(data.rating_lkw_comment);
    }
    dialog.find('.rent-duration').text(data.duration);
    dialog.find('.rent-location').text(data.start_location);
    if (data.next_review != "-1") {
        dialog.find('.next-rating').show();
        dialog.find('.next-rating').data('id', data.next_review);
    }
    else {
        dialog.find('.next-rating').hide();
    }

}

$('.rating-container').on('click', '.rating-details', function () {
    var dialog = $('#detailsRatingDialog');
    var rId = $(this).data('id');
    setRatingData(rId);

    dialog.modal('show');
});


$('#detailsRatingDialog').on('click', '.next-rating', function () {
    var rId = $(this).data("id");
    setRatingData(rId);
});

$(".vehicle_class input").on("click", function () {
    var $vehicle_class = $(this).closest(".vehicle_class")
    var $img = $vehicle_class.find('img');
    var $filename = $img.data('filename');
    if ($(this).is(":checked")) {
        $img.attr("src", "/frontend_dektop/img/" + $filename + "_active.png");
        $vehicle_class.addClass("active");
    } else {
        $vehicle_class.removeClass("active");
        $img.attr("src", "/frontend_dektop/img/" + $filename + ".png");
    }
})

$(".klasse_show_more_ratings").click(function () {
    var city = $("input#current_city").val();
    var country = $("input#current_country").val();
    var url = "/hilfe-kundenbewertungen-klasse/"+city+".html?id=" + country + "&city=" + city;
    $('input[name="fahrzeuge"]:checked').each(function () {
        url += "&fahrzeug[]=" + this.value;
    });
    window.location.href = url + "#bewertungen-liste";
});

$("#serviceSlideInTrigger").on("click", function (e) {
    if ($(this).hasClass('in')) {
        $(this).removeClass('in');
        $("#serviceSlideIn").animate({
            left: '-280px'
        })
        $(".service_box_background").hide();
    } else {
        $("#serviceSlideIn").animate({
            left: '0'
        })
        $(this).addClass('in');
        $(".service_box_background").show();
    }
})

$(".service_box_background").on("click", function () {
    $("#serviceSlideInTrigger").trigger("click");
});


$("#showFilterContainer #show-filter-btn").on("click", function (e) {
    e.preventDefault();
    if ($(this).hasClass('in')) {
        $(this).removeClass('in');
        $("#filterContent").hide();
    } else {
        $("#filterContent").show();
        $(this).addClass('in');
    }
})

$("#showLeaseContainer #show-lease-btn").on("click", function (e) {
    e.preventDefault();
    if ($(this).hasClass('in')) {
        $(this).removeClass('in');
        $("#leaseContent").hide();
    } else {
        $("#leaseContent").show();
        $(this).addClass('in');
    }

})


$("#credit_valid_month").select2({
    minimumResultsForSearch: Infinity,
    width: '100%',
    dropdownCssClass: ':all:'
});
$("#credit_valid_year").select2({
    minimumResultsForSearch: Infinity,
    width: '100%',
    dropdownCssClass: ':all:'
});


// taken from page
$('.features .help-block').click(function () {
    if ($(this).parent().find('input:checkbox').is(':checked')) {
        $(this).parent().removeClass('checked').find('input:checkbox').prop('checked', false);
        $(this).parent().parent().find('.select-box select').prop('disabled', true);
    } else {
        $(this).parent().addClass('checked').find('input:checkbox').prop('checked', true);
        $(this).parent().parent().find('.select-box select').prop('disabled', false);
    }
});


$("[data-type='services']").select2({
    minimumResultsForSearch: Infinity,
    width: '52px',
    dropdownCssClass: ':all:',
});


$('#m-login-tablet').click(function (event) {
    $('.bg-layer').show();
    $('a[aria-controls=bynumber-tablet]').tab('show');
    $('.forgot-id-m').hide();
    $('.login-m').show();
    $('.forgot-pw-m').hide();
    $('.login-view-tablet').show();
    event.stopPropagation();
});

$('#v-login-tablet').click(function (event) {
    $('.bg-layer').show();
    $('.login-v').show();
    $('.forgot-pw-v').hide();
    $('.forgot-id-v').hide();
    $('.vermieter-view-tablet').show();
    event.stopPropagation();
});

$('a[aria-controls=bynumber-tablet]').click(function () {
    var rel = $(this).attr('aria-expanded');
    if (rel == 'true') {
        $('.login-view-tablet').hide();
        $('.tempmsg').hide();
        $('.bg-layer').hide();
    } else {
        $('.bg-layer').show();
        $(this).tab('show');
    }
});

$('a[aria-controls=byaccount-tablet]').click(function () {
    var rel = $(this).attr('aria-expanded');
    if (rel == 'true') {
        $('.login-view-tablet').hide();
        $('.bg-layer').hide();
        $('.tempmsg').hide();
    } else {
        $('.forgot-pw-m2').hide();
        $(this).tab('show');
    }
});

$('a[aria-controls=byvermieter]').click(function () {
    var rel = $(this).attr('aria-expanded');
    if (rel == 'true') {
        $('.vermieter-view-tablet').hide();
        $('.bg-layer').hide();
        $('.tempmsg').hide();
    } else {
        $(this).tab('show');
    }
});

$('.bg-layer').on("click", function (e) {
    $(this).hide();
})

$('button[data-id="login-view-tablet"], button[data-id="vermieter-view-tablet"]').on("click", function () {
    $('.bg-layer').hide();
})

/* Gregor ende */

jQuery(document).ready(function ($) {
    if ($(window).width() <= 768) {
        $('#anmietort').data('width', '334');
    }

    // Auto-collapse/expand filters with hidden elements when scrolling
    var hasScrolled = false;
    var filtersToAutoCollapse = ['#filter-1', '#filter-2', '#filter-3', '#filter-4', '#filter-5', '#filter-7', '#filter-8'];

    $(window).on('scroll', function() {
        var scrollTop = $(window).scrollTop();

        // Collapse filters when scrolling down
        if (!hasScrolled && scrollTop > 100) {
            hasScrolled = true;
            filtersToAutoCollapse.forEach(function(filterId) {
                // Only collapse if it's currently expanded
                if ($(filterId).hasClass('in') || $(filterId).hasClass('show')) {
                    $(filterId).removeClass('in show').addClass('collapsing');
                    setTimeout(function() {
                        $(filterId).removeClass('collapsing').addClass('collapse');
                    }, 350);
                    $('a[href="' + filterId + '"]').attr('aria-expanded', 'false');
                }
            });
        }

        // Expand filters when scrolling back to top
        if (hasScrolled && scrollTop <= 50) {
            hasScrolled = false;
            filtersToAutoCollapse.forEach(function(filterId) {
                // Only expand if it's currently collapsed
                if (!$(filterId).hasClass('in') && !$(filterId).hasClass('show')) {
                    $(filterId).removeClass('collapse').addClass('collapsing');
                    setTimeout(function() {
                        $(filterId).removeClass('collapsing').addClass('collapse in');
                    }, 350);
                    $('a[href="' + filterId + '"]').attr('aria-expanded', 'true');
                }
            });
        }
    });

});

/**
 * Country Select with Flag Icons using Select2
 * Displays country flags in both the dropdown list and selected option
 */
$(document).ready(function() {
    var $countrySelect = $('#search_country');

    if ($countrySelect.length && typeof $.fn.select2 !== 'undefined') {
        // Custom template for displaying flags
        function formatCountryOption(option) {
            if (!option.id) {
                return option.text;
            }
            var countryCode = $(option.element).data('country-code') || 'eu';
            return $('<span><span class="fi fi-' + countryCode + '" style="margin-right: 8px;"></span>' + option.text + '</span>');
        }

        // Initialize Select2 with custom templates
        $countrySelect.select2({
            templateResult: formatCountryOption,
            templateSelection: formatCountryOption,
            minimumResultsForSearch: Infinity, // Disable search box
            width: '100%',
            dropdownAutoWidth: false
        });

        // Hide the manual flag container since Select2 handles it now
        $('#selected_country_flag').hide();
    }
});

/**
 * Show/hide holiday warning message
 * @param {string} inputSelector - Selector for the datepicker input
 * @param {Object|null} holiday - Holiday info from GermanHolidays.getHoliday()
 */
function showHolidayWarning(inputSelector, holiday) {
    var $input = $(inputSelector);
    var $container = $input.closest('.form-group, .input-group, .col-sm-6, .date-field');
    var $warning = $container.find('.holiday-warning');

    if (holiday) {
        // Create warning element if it doesn't exist
        if ($warning.length === 0) {
            $warning = $('<div class="holiday-warning">' +
                '<i class="fa fa-info-circle holiday-icon"></i> ' +
                '<span class="holiday-text">Hinweis: <strong class="holiday-name"></strong> - ' +
                'Bitte beachten Sie, dass Abholung/Rückgabe an Feiertagen möglicherweise eingeschränkt ist.</span>' +
                '</div>');
            $container.append($warning);
        }

        $warning.find('.holiday-name').text(holiday.name);
        $warning.addClass('show');
    } else {
        // Hide warning if no holiday
        $warning.removeClass('show');
    }
}

// Export validation functions to global scope for use in inline scripts
// These functions are called from PHP templates (checkout-kundendaten.php)
if (typeof window !== 'undefined') {
    window.validateName = validateName;
    window.validateStreet = validateStreet;
    window.validateStreetNo = validateStreetNo;
    window.validateZip = validateZip;
    window.phoneCountry = phoneCountry;
    window.phoneNumber = phoneNumber;
    window.validateCardnumberAmex = validateCardnumberAmex;
    window.validateCardnumberDiners = validateCardnumberDiners;
    window.validateCardnumberMaster = validateCardnumberMaster;
    window.validateCardnumberVisa = validateCardnumberVisa;
    window.validateCvc = validateCvc;
    window.validateCvc4 = validateCvc4;
    window.validateEmail = validateEmail;
    window.capitalizeFirstLetter = capitalizeFirstLetter;
    window.showHolidayWarning = showHolidayWarning;
}

